import React, { useState, useEffect, useRef } from 'react';
import Logo from '../images/logoGrandePreta.jpg';
import { usePDF } from 'react-to-pdf';
import BotaoGerarPDF from './GerarPDFComReactPDF';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { IoMdClose } from 'react-icons/io';
import { MdOutlineDoNotDisturbAlt } from 'react-icons/md';

import Loading from './Loading';

import {
	requestClassByProtocol,
	requestSavedData,
	requestNewInvCreation,
	requestListNotesByProtocol,
	requestSaveForm,
	requestNewUnits,
	requestNoteTimeLine,
	requestNewClassCreation,
	requestInvConclude,
	requestNewAvalCreation,
	requestAvalList,
	requestUsersCnes,
	requestEmailSend,
} from '../services/requests';
import Json from '../utils/tipos_incidentes.json';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import NeverJson from '../utils/never_events.json';
import tiposIncidentes from '../utils/tipos_incidentes.json';
import classificacoes from '../utils/classificacoes.json';
import { FaRegFilePdf } from 'react-icons/fa';
import Cookies from 'js-cookie';

function ClassInvForm({ notificacao, cards }) {
	const [carregando, setCarregando] = useState(false);
	const [emailAlert, setEmailAlert] = useState(false);
	const [concluido, setConcluido] = useState(false);
	const [subReclassForm, setSubReclassForm] = useState('');
	const [reIncidentForm, setReIncidentForm] = useState('');
	const [reclassForm, setReclassForm] = useState('');
	const [reclass, setReclass] = useState(false);
	const [rejectCard, setRejectCard] = useState('');
	const [formSalvo, setFormSalvo] = useState(false);
	const [justificativa, setJustificativa] = useState('');
	const [noteId, setNoteId] = useState('');
	const [invAlert, setInvAlert] = useState(false);
	const [invId, setInvId] = useState('');
	const [pdfBaixado, setPdfBaixado] = useState(false);
	const [justAlert, setJustAlert] = useState(false);
	const [emailsAlert, setEmailsAlert] = useState(false);
	const [investigadorList, setInvestigadorList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [concludeEmails, setConcludeEmails] = useState(['']);
	const [rejeicao, setRejeicao] = useState('');
	const [textReject, setTextReject] = useState(false);
	const [invUsers, setInvUsers] = useState([]);
	const [validDate, setValidDate] = useState(true);
	const [textBox, setTextBox] = useState(false);
	const [textBoxSend, setTextBoxSend] = useState(false);
	const [yesCheck, setYesCheck] = useState('');
	const [buttonLoading, setButtonLoading] = useState(false);
	const [formLayout, setFormLayout] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [enviado, setEnviado] = useState(false);
	const [copiado, setCopiado] = useState(false);
	const [counter, setCounter] = useState(1);
	const [cronCounter, setCronCounter] = useState(1);
	const [incident1Counter, setIncident1Counter] = useState(1);
	const [planCounter, setPlanCounter] = useState(1);
	const [isButtonEnabled, setIsButtonEnabled] = useState(true);
	const [emailCounter, setEmailCounter] = useState(1);

	const [invForm, setInvForm] = useState({
		coleta_dados: '',
		investigacao_concluida: false,
		equipe_investigacao_data: [
			{
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			},
		],
		cronologia_incidentes_data: [
			{
				evento: '',
				data: '',
				hora: '',
				setor: '',
				descricao: '',
			},
		],
		definicao_causas_data: {
			fator_paciente: '',
			fator_profissional: '',
			fator_tarefa: '',
			fator_comunicacao: '',
			fator_equipamento: '',
			fator_ambiente: '',
			fator_organizacional: '',
			fator_treinamento: '',
		},
		plano_acoes_data: [
			{
				causas_prioritarias: '',
				acoes_planejadas: '',
				responsavel: '',
				prazo: '',
				status: '',
			},
		],
	});

	const [finalForm, setFinalForm] = useState({
		investigacao: '',
		acoes_realizadas: '',
		padrao_trabalho: '',
		observacoes: '',
	});

	const [classForm, setClassForm] = useState({
		notificacao: '',
		classificacao: '',
		sub_classificacao: '',
		prazo_investigacao: '',
	});

	const [form, setForm] = useState({
		unidade_token_notificacao: '',
		data_notificacao: '',
		data_ocorrencia: '',
		unidade: '',
		turno: '',
		setor: '',
		nome_paciente: '',
		sexo_paciente: '',
		nascimento_paciente: '',
		prontuario: '',
		notificador: '',
		tipo_incidente: '',
		quem_presenciou: '',
		envolve_paciente: false,
		descricao_ocorrencia: '',
		acoes_imediatas: '',
		medida_preventiva: '',
		other_checked: false,
		fato_presenciado: false,
	});

	const formRef = useRef(null);

	function formatDate(dataStr) {
		if (!dataStr) return '';
		const dataApenas = dataStr.split('T')[0];

		const [ano, mes, dia] = dataApenas.split('-');

		if (!ano || !mes || !dia) {
			return 'Data inválida';
		}

		return `${dia}/${mes}/${ano}`;
	}

	const handleReclassForm = (value) => {
		setReclassForm(value);
	};

	const handleReIncident = (value) => {
		setReIncidentForm(value);
	};

	const handleSubReclassForm = (event) => {
		if (reclass === 'false') {
			setReclassForm({ ...reclassForm, sub_classificacao: '' });
		} else {
			let value = event.target.value;
			setSubReclassForm(value);
		}
	};

	const requestUsers = async () => {
		const users = await requestUsersCnes(
			JSON.parse(Cookies.get('user')).token,
			JSON.parse(Cookies.get('user')).id
		);
		if (users) {
			let result = users.filter((user) =>
				user.perfil_unidades.some(
					(perfil) =>
						perfil.unidade_id.replace(/-/g, '') ===
							form.unidade_token_notificacao
								.split('')
								.reverse()
								.join('') &&
						perfil.ativo &&
						perfil.groups.includes('Investigadores') &&
						!perfil.groups.includes('Gestores')
				)
			);
			setInvUsers(result);
		}
	};

	const isRejected = async () => {
		const protocolo = notificacao.protocolo;
		const result = await requestNoteTimeLine(protocolo);
		if (!result.error) {
			if (
				(result.status === 'CONCLUIDO' &&
					result.data_avaliacao === null) ||
				result.status === 'CLASSIFICADO'
			) {
				setConcluido(true);
			}
		}
	};

	const handleSaveInv = async () => {
		setFormSalvo(false);
		setCarregando(true);

		const token = JSON.parse(Cookies.get('user')).token;
		const id = invId;

		const equipe = Object.values(invForm.equipe_investigacao_data).map(
			(item) => ({
				investigacao: id,
				nome_completo: item.nome_completo,
				setor: item.setor,
				cargo: item.cargo,
				email: item.email,
			})
		);

		const planos = Object.values(invForm.plano_acoes_data).map((item) => ({
			investigacao: id,
			causas_prioritarias: item.causas_prioritarias,
			acoes_planejadas: item.acoes_planejadas,
			responsabilidade: item.responsavel,
			prazo: item.prazo,
			status: item.status?.toUpperCase() || '',
		}));

		const cronologia = Object.values(
			invForm.cronologia_incidentes_data
		).map((item) => ({
			investigacao: id,
			evento: item.evento,
			data_evento: item.data,
			hora_evento: item.hora,
			local: item.setor,
			descricao: item.descricao,
		}));

		const causas = {
			investigacao: id,
			fatores_paciente: invForm.definicao_causas_data.fator_paciente,
			fatores_profissionais:
				invForm.definicao_causas_data.fator_profissional,
			fatores_tarefa: invForm.definicao_causas_data.fator_tarefa,
			fatores_comunicacao:
				invForm.definicao_causas_data.fator_comunicacao,
			fatores_equipe: invForm.definicao_causas_data.fator_equipe,
			fatores_ambiente: invForm.definicao_causas_data.fator_ambiente,
			fatores_organizacionais:
				invForm.definicao_causas_data.fator_organizacional,
			fatores_treinamento:
				invForm.definicao_causas_data.fator_treinamento,
			fatores_equipamento:
				invForm.definicao_causas_data.fator_equipamento,
		};

		try {
			const resEquipe = await requestSaveForm(
				token,
				id,
				'equipe',
				equipe
			);

			const resPlanos = await requestSaveForm(
				token,
				id,
				'planos-acao',
				planos
			);

			const resColeta = await requestSaveForm(token, id, 'coleta-dados', {
				investigacao: id,
				dados_coletados: invForm.coleta_dados,
			});

			const resCronologia = await requestSaveForm(
				token,
				id,
				'cronologia',
				cronologia
			);

			const resCausas = await requestSaveForm(
				token,
				id,
				'causas',
				causas
			);
		} catch (error) {
			console.error('Erro ao salvar investigação:', error);
		} finally {
			setCarregando(false);
			setFormSalvo(true);
		}
	};

	const handleCopy = (event) => {
		const content = event?.target?.value; // Conteúdo específico
		navigator.clipboard
			.writeText(content)
			.then(() => {
				setCopiado(true);
			})
			.catch((err) => {
				console.error('Erro ao copiar:', err);
			});
	};

	const handleInvalid = async () => {
		/* 	console.log(notificacao.protocolo); */
		if (notificacao.status !== 'NOTIFICADO') return;
		const isEmailEmpty =
			concludeEmails.length === 1 && concludeEmails[0] === '';
		const isJustificativaEmpty = !justificativa.length;

		if (isEmailEmpty || isJustificativaEmpty) {
			if (!textBox && isEmailEmpty && isJustificativaEmpty)
				return setTextBox(true);
			isEmailEmpty && setEmailsAlert(true);
			isJustificativaEmpty && setJustAlert(true);
			return;
		}

		if (!window.confirm('Deseja realmente concluir esta notificação?'))
			return;

		const token = JSON.parse(Cookies.get('user')).token;

		let a = {
			...classForm,
			protocolo: notificacao.protocolo,
			descartar: true,
			justificativa_descarte: justificativa,
			investigadores_lista: invUsers
				.filter((o) => investigadorList.includes(o.email))
				.map((o) => o.username),
			prazo_investigacao: null,
		};

		const [emailResult, creationResult] = await Promise.all([
			requestEmailSend(token, {
				template_id: 3,
				destinatarios: concludeEmails,
				variaveis: {
					protocolo: notificacao.protocolo,
					observacao: justificativa,
				},
			}),

			requestNewClassCreation(token, {
				protocolo: notificacao.protocolo,
				classificacao: '',
				sub_classificacao: '',
				descartar: true,
				justificativa_descarte: justificativa,
				investigadores_lista: [],
				prazo_investigacao: null,
			}),
		]);

		emailResult && creationResult && handleGeneratePDF('conclusão');
	};

	const handleReject = async () => {
		const token = JSON.parse(Cookies.get('user')).token;

		const emails = await requestClassByProtocol(
			token,
			notificacao.protocolo
		);
		if (textReject === false) {
			setTextReject(true);
		} else if (notificacao.status === 'INVESTIGADO') {
			if (rejeicao.length === 0) {
				setTextReject(true);
			} else {
				let a = {
					investigacao: invId,
					decisao: 'REJEITADA',
					acoes_realizadas: false,
					pontos_trabalho: false,
					padrao_trabalho: false,
					observacoes: finalForm.observacoes,
					tipo_incidente_adequado: true,
					classificacao_adequada: true,
					motivo_rejeicao: rejeicao,
				};
				if (textReject === true) {
					setRejectCard('clicked');
					if (rejectCard === 'clicked') {
						const response = await requestNewAvalCreation(
							JSON.parse(Cookies.get('user')).token,
							a
						);

						const prodToken =
							'81eedc273fd7f14c01edd98a75529a94e6563c06';
						const resulter = await requestEmailSend(prodToken, {
							template_id: 4,
							destinatarios:
								emails.investigadores.map((item) => item.email)
									?.length > 0
									? emails.investigadores.map(
											(item) => item.email
									  )
									: [],
							variaveis: {
								protocolo: notificacao.protocolo,
								justificativa: rejeicao,
							},
						});

						if (!response.error) {
							setRejectCard('send');
						}
					}
				}
			}
		}
	};

	const handleGeneratePDF = (param) => {
		setFormLayout(true); // Ativa o layout fixo para evitar mudanças de estilo
		const input = formRef.current;

		// Ajusta o layout para tamanhos fixos
		input.style.width = '1236px';
		input.style.minHeight = '1123px';

		// IDs dos blocos na ordem que você deseja renderizar
		let blocks = ['block1', 'block2', 'block3', 'block4'];
		if (
			param === 'conclusão' &&
			(notificacao?.status === 'NOTIFICADO' ||
				notificacao?.status === 'CLASSIFICADO')
		) {
			blocks = ['block1'];
		} else if (
			notificacao?.status === 'NOTIFICADO' ||
			notificacao?.status === 'CLASSIFICADO'
		) {
			blocks = ['block1', 'block2'];
		}

		const margin = 10; // Margem do PDF
		const spacing = 4; // Espaçamento entre seções
		const pdf = new jsPDF('p', 'mm', 'a4'); // Configura o PDF
		const pageHeight = pdf.internal.pageSize.height - 2 * margin; // Altura útil da página do PDF
		let currentY = margin; // Mantém o rastreamento da posição vertical atual no PDF

		// Função para esperar o carregamento de imagens antes de capturar
		const loadImages = async (element) => {
			const images = element.getElementsByTagName('img');
			const promises = [...images].map((img) => {
				return new Promise((resolve) => {
					if (img.complete) {
						resolve();
					} else {
						img.onload = img.onerror = resolve;
					}
				});
			});
			await Promise.all(promises);
		};

		// Renderiza uma seção no PDF
		const renderSection = async (section) => {
			await loadImages(section); // Aguarda imagens carregarem
			const canvas = await html2canvas(section, {
				scale: 2,
				useCORS: true,
			});
			const imgData = canvas.toDataURL('image/jpeg', 1);
			const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
			const canvasWidth = canvas.width;
			const canvasHeight = canvas.height;
			const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;

			// Verifica se a seção cabe na página atual
			if (currentY + imgHeight > pageHeight) {
				pdf.addPage();
				currentY = margin; // Reseta para o topo da nova página
			}

			// Adiciona a imagem da seção ao PDF
			pdf.addImage(
				imgData,
				'JPEG',
				margin,
				currentY,
				pdfWidth,
				imgHeight
			);
			currentY += imgHeight + spacing; // Atualiza a posição vertical com espaçamento
		};

		// Renderiza um bloco no PDF, exceto o primeiro bloco
		const renderBlock = async (blockId) => {
			const block = document.getElementById(blockId);
			if (!block) {
				console.error(`Elemento com ID ${blockId} não encontrado!`);
				return;
			}

			const sections = Array.from(block.children);
			for (const section of sections) {
				await renderSection(section);
			}
		};

		// Renderiza o primeiro bloco diretamente na primeira página
		const renderFirstBlock = async (blockId) => {
			const block = document.getElementById(blockId);
			if (!block) {
				console.error(`Elemento com ID ${blockId} não encontrado!`);
				return;
			}

			await loadImages(block); // Aguarda imagens carregarem
			const canvas = await html2canvas(block, {
				scale: 2,
				useCORS: true,
			});
			const imgData = canvas.toDataURL('image/jpeg', 1);
			const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
			const canvasWidth = canvas.width;
			const canvasHeight = canvas.height;
			const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;

			// Adiciona o bloco diretamente na primeira página
			pdf.addImage(imgData, 'JPEG', margin, margin, pdfWidth, imgHeight);
			currentY = imgHeight + margin; // Atualiza a posição vertical para o próximo conteúdo
		};

		const generatePDF = async () => {
			// Aguarda um pequeno delay para garantir que os estilos foram aplicados
			await new Promise((resolve) => setTimeout(resolve, 300));

			// Renderiza o primeiro bloco de forma fixa
			await renderFirstBlock(blocks[0]);

			// Renderiza os outros blocos normalmente
			for (let i = 1; i < blocks.length; i++) {
				await renderBlock(blocks[i]);
			}

			// Criar um Blob do PDF
			if (param === 'download') {
				pdf.save(`${notificacao?.protocolo}.pdf`);
			}
			const pdfBlob = pdf.output('blob');

			// Criar um URL temporário para o Blob
			const pdfUrl = URL.createObjectURL(pdfBlob);

			// Salvar o link no localStorage

			// Opcional: Salvar em cookie (válido por 1 dia)
			document.cookie = `pdfUrl=${pdfUrl}; max-age=86400; path=/`;

			/* pdf.save(`${notificacao?.protocolo}`); */ // Salva o PDF após renderizar todos os blocos

			// Restaura o layout original
			setFormLayout(false);
			input.style.width = '';
			input.style.minHeight = '';

			// Aguarda um pequeno delay para garantir que o estado foi atualizado

			setTimeout(() => {
				if (param !== 'download') {
					setEnviado(true);
				}
				setButtonLoading(false);
			}, 500);
		};

		// Aguarda o layout ser aplicado antes de começar
		setTimeout(() => {
			generatePDF();
			setButtonLoading(true);
		}, 500);
	};

	const handleDownloadPDF = () => {
		const pdfUrl = localStorage.getItem('pdfUrl') || getCookie('pdfUrl');
		if (pdfUrl) {
			const link = document.createElement('a');
			link.href = pdfUrl;
			link.download = `${notificacao?.protocolo}.pdf`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	};

	const handleEmails = (indice, valor) => {
		let a = concludeEmails;
		a[indice] = valor;

		setConcludeEmails(a);
	};

	// Função para recuperar cookie
	const getCookie = (name) => {
		const cookies = document.cookie.split('; ');
		const cookie = cookies.find((row) => row.startsWith(name));
		return cookie ? cookie.split('=')[1] : null;
	};

	const handleFinal = (chave, valor) => {
		let prev = finalForm;
		let acoes;
		valor === 'sim' ? (acoes = true) : (acoes = false);

		let padroes;
		valor === 'sim' ? (padroes = true) : (padroes = false);
		if (chave === 'acoes_realizadas') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				acoes_realizadas: acoes,
			}));
			sendButtonEnabled({
				...prev,
				acoes_realizadas: acoes,
			});
		}

		if (chave === 'observacoes') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				observacoes: valor,
			}));
			sendButtonEnabled({
				...prev,
				observacoes: valor,
			});
		}

		if (chave === 'padroes_trabalho') {
			setFinalForm((prevFormData) => ({
				...prevFormData,
				padrao_trabalho: padroes,
			}));
			sendButtonEnabled({
				...prev,
				padrao_trabalho: padroes,
			});
		}
	};

	const moment = require('moment');
	require('moment/locale/pt-br');
	moment.locale('pt-br');

	/* const incidentTypes = [
		'Falha na identificação do paciente',
		'Falha na terapia medicamentosa',
		'Falha na segurança cirúrgica',
		'Queda ou quase queda do paciente',
		'Lesão por pressão adquirida após admissão do paciente',
		'Reações transfusionais ou falhas com hemocomponentes',
		'Incidente envolvendo a dieta',
		'Falha no transporte/transferência do paciente',
		'Falha relacionada ao uso de gases/oxigênio/vapor',
		'Falha relacionada a exames e/ou diagnósticos',
		'Falha operacional de equipamentos ou dispositivos médicos',
		'Falha relacionada à infraestrutura, edifício ou instalações',
		'Falhas na comunicação e/ou documentação',
		'Contenção, suicídio ou dano autoinfligido',
		'Evasão de paciente',
	]; */

	const handleForm = (value, id) => {
		const findValueFromDisplay = (displayValue) => {
			let word = displayValue.trim();
			const result = Json.find((item) => item.display === word);
			return result ? result.value : '';
		};

		if (id === 'tipo_incidente') {
			setForm((prevForm) => ({
				...prevForm,
				tipo_incidente: findValueFromDisplay(value),
			}));
		} else {
			setForm((prevForm) => ({ ...prevForm, [id]: value }));
		}
	};

	const isFormValid = () => {
		return Object.entries(form).every(
			([key, value]) =>
				[
					'nome_paciente',
					'sexo_paciente',
					'nascimento_paciente',
					'notificador',
				].includes(key) || value !== ''
		);
	};

	const handleSubmit = async () => {
		if (notificacao.status === 'NOTIFICADO') {
			if (textBoxSend === true) {
				if (!isButtonEnabled) {
					if (yesCheck && investigadorList.length > 0) {
						let a = {
							...classForm,
							protocolo: notificacao.protocolo,
							descartar: false,
							motivo_descarte: false,
							justificativa_descarte: '',
							investigadores_lista: invUsers
								.filter((o) =>
									investigadorList.includes(o.email)
								)
								.map((o) => o.username),
							prazo_investigacao:
								classForm.classificacao === 'OBITO' ||
								classForm.classificacao === 'GRAVE' ||
								(classForm.classificacao === 'NEVER_EVENTS' &&
									classForm.sub_classificacao.length > 0)
									? null
									: classForm.prazo_investigacao,
						};
						const result = await requestNewClassCreation(
							JSON.parse(Cookies.get('user')).token,
							a
						);
						if (!result.error) {
							setButtonLoading(true);
							setIsButtonEnabled(true);
							const emailSend = await requestEmailSend(
								JSON.parse(Cookies.get('user')).token,
								{
									template_id: 2,
									destinatarios: investigadorList,
									variaveis: {
										nome: 'Investigador(a)',
										protocolo: notificacao.protocolo,
										prazo: classForm.prazo_investigacao,
										classificacao: classForm.classificacao,
									},
								}
							);
							if (emailSend.error) {
								console.log(emailSend.error);
								return;
							}
							handleGeneratePDF();
							console.log('Formulário classificado com sucesso');
						} else {
							console.log(result?.error);
							return;
						}
					} else if (yesCheck && investigadorList.length === 0) {
						setInvAlert(true);
					} else if (
						yesCheck === false &&
						investigadorList.length === 0
					) {
						let a = {
							...classForm,
							protocolo: notificacao.protocolo,
							descartar: false,
							justificativa_descarte: '',
							investigadores_lista: invUsers.map(
								(o) => o.username
							),

							prazo_investigacao:
								classForm.classificacao === 'OBITO' ||
								classForm.classificacao === 'GRAVE' ||
								(classForm.classificacao === 'NEVER_EVENTS' &&
									classForm.sub_classificacao.length > 0)
									? null
									: classForm.prazo_investigacao,
						};
						const result = await requestNewClassCreation(
							JSON.parse(Cookies.get('user')).token,
							a
						);
						if (result.error) {
							console.log(result.error);
							return;
						} else {
							handleGeneratePDF();
							console.log('Formulário classificado com sucesso');
						}
					}
				}
			} else {
				setTextBoxSend(true);
			}
		}

		if (notificacao.status === 'CLASSIFICADO') {
			await handleSaveInv(); // Aguarda a finalização de handleSaveInv antes de continuar

			if (!sendButtonEnabled()) {
				const result = await requestInvConclude(
					JSON.parse(Cookies.get('user')).token,
					invId,
					{
						id: invId,
						protocolo: notificacao.protocolo,
						concluida: true,
					}
				);

				if (result.error) {
					console.log(result.error);
					return;
				} else {
					console.log('Formulário Investigado com sucesso');
					handleGeneratePDF();
					/* setEnviado(true); */
				}
			}
		}

		if (notificacao.status === 'INVESTIGADO') {
			if (!sendButtonEnabled()) {
				if (
					reclass === true &&
					(reclassForm.length === 0 ||
						(reclassForm === 'NEVER_EVENTS' &&
							subReclassForm.length === 0) ||
						(reclassForm === '' && subReclassForm.length > 0) ||
						reIncidentForm.length === 0)
				) {
					console.log(
						'Erro ao avaliar o formulário: reclassificação ou reclassificação de incidente inválida.'
					);
				} else {
					const result = await requestNewAvalCreation(
						JSON.parse(Cookies.get('user')).token,
						{
							investigacao: invId,
							decisao: 'ACEITA',
							acoes_realizadas: finalForm?.acoes_realizadas,
							pontos_trabalho: finalForm?.padrao_trabalho,
							padrao_trabalho: finalForm?.padrao_trabalho,
							observacoes: finalForm?.observacoes,
							motivo_rejeicao: '',
							classificacao_adequada: !reclass,
							classificacao_final: reclass ? reclassForm : '',
							sub_classificacao_final: subReclassForm,
							tipo_incidente_adequado: !reclass,
							tipo_incidente_final: reclass ? reIncidentForm : '',
						}
					);

					if (result.error) {
						console.log(result.error);
						return;
					} else {
						console.log('Formulário Avaliado com sucesso');
						handleGeneratePDF();
						/* setEnviado(true); */
					}
				}
			}
		}
	};
	const handleColeta = (id, nome, valor) => {
		let key = nome;
		let value = valor;
		let prevForm = invForm;
		prevForm[key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};

	const handleInvSelected = (value) => {
		if (investigadorList.length < 5 && !investigadorList.includes(value)) {
			setIsLoading(true);
			let a = investigadorList;
			a.push(value);

			setInvestigadorList(a);
			setTimeout(() => {
				setIsLoading(false);
			}, 1000);
		}
	};

	const setUnitToken = async () => {
		const units = await requestNewUnits();
		const unit = units.find(
			(unit) =>
				decodeURIComponent(
					String(window.location.pathname).split('/')[2]
				) === unit.nome
		);
		setForm((prevForm) => ({
			...prevForm,
			unidade_token_notificacao: unit.token_notificacao,
		}));
	};

	/* 
NÃO MEXER NESSA LOGICA PRA NAO QUEBRAR AS REGRAS */
	const handleClassForm = (event) => {
		setTextBoxSend(false);
		const { id, value } = event.target;
		let prev = classForm;
		if (id === 'classificacao' && value !== 'NEVER_EVENTS') {
			if (value === 'GRAVE' || value === 'OBITO') {
				const dataFutura = new Date();
				dataFutura.setDate(dataFutura.getDate() + 2); // Adiciona 2 dias
				const prazoInvestigacao = dataFutura
					.toLocaleDateString('pt-BR')
					.split('/')
					.join('-'); // Formata para 'dd-MM-yyyy'

				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: prazoInvestigacao,
				}));
				setValidDate(false);
			} else {
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: '',
				}));
				sendButtonEnabled({
					...prev,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: '',
				});
				setIsButtonEnabled(true);
			}
		}
		if (id === 'prazo_investigacao') {
			const selectedDate = new Date(value);
			const today = new Date();
			today.setHours(0, 0, 0, 0); // Ajustar para ignorar a hora

			if (selectedDate <= today) {
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value, // Atualiza apenas a chave correspondente ao id
				}));
				setValidDate(true);
				sendButtonEnabled(
					{
						...prev,
						[id]: value, // Atualiza apenas a chave correspondente ao id
					},
					true
				);
			} else {
				setValidDate(false);
				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value, // Atualiza apenas a chave correspondente ao id
				}));
				sendButtonEnabled(
					{
						...prev,
						[id]: value, // Atualiza apenas a chave correspondente ao id
					},
					false
				);
			}
		} else {
			if (id === 'classificacao' && value === 'NEVER_EVENTS') {
				const dataFutura = new Date();
				dataFutura.setDate(dataFutura.getDate() + 2); // Adiciona 2 dias

				const prazoInvestigacao = dataFutura
					.toLocaleDateString('pt-BR')
					.split('/')
					.join('-'); // Formata para 'dd-MM-yyyy'

				setClassForm((prevFormData) => ({
					...prevFormData,
					[id]: value,
					sub_classificacao: '',
					prazo_investigacao: prazoInvestigacao,
				}));
				sendButtonEnabled({
					...prev,
					[id]: value, // Atualiza apenas a chave correspondente ao id
				});

				setValidDate(false);
			} else {
				if (value === 'OBITO' || value === 'GRAVE') {
					setIsButtonEnabled(false);
				} else if (id === 'sub_classificacao') {
					setClassForm((prevFormData) => ({
						...prevFormData,
						[id]: value, // Atualiza apenas a chave correspondente ao id
					}));
					sendButtonEnabled({
						...prev,
						[id]: value, // Atualiza apenas a chave correspondente ao id
					});
				} else {
					setIsButtonEnabled(true);
				}
			}
		}
	};

	const handleEquipe = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;
		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addEquipe = (id) => {
		if (id === 'adcionar') {
			setCounter(counter + 1);
			let newForm = invForm;
			newForm.equipe_investigacao_data.push({
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			});
			setInvForm(newForm);
		}
		if (id === 'remover') {
			if (counter > 1) {
				setCounter(counter - 1);
				let newForm = invForm;
				newForm.equipe_investigacao_data.pop();
			}
		}
		sendButtonEnabled();
	};

	const handleCronologia = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;
		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addCronologia = (id) => {
		if (id === 'adcionar') {
			setCronCounter(cronCounter + 1);
			let newForm = invForm;
			newForm.cronologia_incidentes_data.push({
				evento: '',
				data: '',
				hora: '',
				setor: '',
				descricao: '',
			});
			setInvForm(newForm);
			sendButtonEnabled();
		}
		if (id === 'remover') {
			if (cronCounter > 1) {
				setCronCounter(cronCounter - 1);
				let newForm = invForm;
				newForm.cronologia_incidentes_data.pop();
				sendButtonEnabled();
			}
		}
	};

	const handlePlano = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;

		prevForm[object][position][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	const addPlano = (id) => {
		if (id === 'adcionar') {
			setPlanCounter(planCounter + 1);
			let newForm = invForm;

			newForm.plano_acoes_data.push({
				causas_prioritarias: '',
				acoes_planejadas: '',
				responsavel: '',
				prazo: '',
				status: '',
			});

			setInvForm(newForm);
			sendButtonEnabled();
		}
		if (id === 'remover') {
			if (planCounter > 1) {
				setPlanCounter(planCounter - 1);
				let newForm = invForm;
				newForm.plano_acoes_data.pop();
				sendButtonEnabled();
			}
		}
	};

	const handleCausas = (id, nome, valor) => {
		let position = id.split('/')[0].trim();
		let object = id.split('/')[1].trim();
		let key = nome;
		let value = valor;
		setFormSalvo(false);

		let prevForm = invForm;
		prevForm[object][key] = value;
		setInvForm(prevForm);
		sendButtonEnabled();
	};
	/* const addCausas = (id) => {
		if (id === 'adcionar') {
			setCronCounter(cronCounter + 1);
			let newForm = invForm;
			newForm.cronologia_incidentes_data.push({
				nome_completo: '',
				cargo: '',
				setor: '',
				email: '',
			});
			setInvForm(newForm);
		}
		if (id === 'remover') {
			if (cronCounter > 1) {
				setCronCounter(cronCounter - 1);
				let newForm = invForm;
				newForm.cronologia_incidentes_data.pop();
			}
		}
	}; */

	const hasEmptyFields = (obj) => {
		for (const key in obj) {
			const value = obj[key];

			// Verifica valores vazios, null ou undefined
			if (value === '' || value === null || value === undefined) {
				return true;
			}

			// Verifica arrays
			if (Array.isArray(value)) {
				for (const item of value) {
					if (hasEmptyFields(item)) return true;
				}
			}

			// Verifica objetos aninhados
			if (
				typeof value === 'object' &&
				value !== null &&
				!Array.isArray(value)
			) {
				if (hasEmptyFields(value)) return true;
			}
		}
		return false; // Retorna false se nenhum campo vazio foi encontrado
	};

	const sendButtonEnabled = (data, stat) => {
		if (notificacao?.status === 'NOTIFICADO') {
			const { classificacao, sub_classificacao, prazo_investigacao } =
				data;
			if (!prazo_investigacao || !classificacao) {
				if (
					classificacao === 'GRAVE' ||
					classificacao === 'OBITO' ||
					(classificacao === 'NEVER_EVENTS' &&
						sub_classificacao.length > 0)
				) {
					return setIsButtonEnabled(false);
				}
				return setIsButtonEnabled(true);
			} else if (classificacao === 'NEVER_EVENTS' && !sub_classificacao) {
				return setIsButtonEnabled(true);
			} else if (
				classificacao !== 'NEVER_EVENTS' &&
				sub_classificacao === '' &&
				new Date(prazo_investigacao) > new Date()
			) {
				return setIsButtonEnabled(false);
			} else if (
				classificacao !== 'NEVER_EVENTS' &&
				sub_classificacao !== ''
			) {
				return setIsButtonEnabled(true);
			} else {
				if (new Date(prazo_investigacao) > new Date()) {
					return setIsButtonEnabled(false);
				} else {
					if (
						classificacao === 'OBITO' ||
						classificacao === 'GRAVE' ||
						(classificacao === 'NEVER_EVENTS' &&
							sub_classificacao.length > 0)
					) {
						setIsButtonEnabled(false);
						return setIsButtonEnabled(false);
					}
					return setIsButtonEnabled(true);
				}
			}
		}
		if (notificacao.status === 'CLASSIFICADO') {
			return setIsButtonEnabled(hasEmptyFields(invForm));
		}
		if (notificacao.status === 'INVESTIGADO') {
			if (data) {
				let verify = Object.entries(data).every(
					([key, value]) =>
						key === 'investigacao' ||
						(value !== null && value !== undefined && value !== '')
				);

				return setIsButtonEnabled(!verify);

				/* return setIsButtonEnabled(); */
			}
		}
	};

	const listAval = async () => {
		let result = await requestAvalList(
			JSON.parse(Cookies.get('user')).token
		);

		if (result.length > 0) {
			let marcos = result.filter(
				(item) => item.protocolo === notificacao.protocolo
			)[0];

			if (
				marcos?.classificacao_final !== '' ||
				marcos?.tipo_incidente_final !== ''
			) {
				setReclass(true);
				setFinalForm({
					investigacao: marcos?.investigacao,
					acoes_realizadas: marcos?.acoes_realizadas,
					padrao_trabalho: marcos?.padrao_trabalho,
					observacoes: marcos?.observacoes,
					classificacao_final: marcos?.classificacao_final,
					sub_classificacao_final: marcos?.sub_classificacao_final,
					tipo_incidente_final: marcos?.tipo_incidente_final,
				});
			} else {
				setFinalForm({
					investigacao: marcos?.investigacao,
					acoes_realizadas: marcos?.acoes_realizadas,
					padrao_trabalho: marcos?.padrao_trabalho,
					observacoes: marcos?.observacoes,
				});
			}
		}
	};
	const perRequest = async () => {
		const token = JSON.parse(Cookies.get('user')).token;
		const newForm = await requestListNotesByProtocol(
			token,
			notificacao.protocolo
		);
		if (!newForm.error) {
			setForm({
				...form,
				envolve_paciente: newForm.envolve_paciente,
				quem_presenciou: newForm.quem_presenciou,
				nome_paciente: newForm.nome_paciente,
				sexo_paciente: newForm.sexo_paciente,
				nascimento_paciente: newForm.nascimento_paciente,
				prontuario: newForm.prontuario,
			});
		}
		const result = await requestClassByProtocol(
			token,
			notificacao.protocolo
		);
		const inv = await requestNewInvCreation(token, notificacao?.protocolo);
		if (inv.error) {
			setInvId(inv?.error?.response?.data?.investigacao_id);
			/* const list = ['equipe', 'planos-acao', 'cronologia', 'causas']; */
			const equipe = await requestSavedData(
				token,
				inv?.error?.response?.data?.investigacao_id,
				'equipe'
			);
			const planos = await requestSavedData(
				token,
				inv?.error?.response?.data?.investigacao_id,
				'planos-acao'
			);
			const cronologia = await requestSavedData(
				token,
				inv?.error?.response?.data?.investigacao_id,
				'cronologia'
			);
			const causas = await requestSavedData(
				token,
				inv?.error?.response?.data?.investigacao_id,
				'causas'
			);

			const coleta = await requestSavedData(
				token,
				inv?.error?.response?.data?.investigacao_id,
				'coleta-dados'
			);

			if (coleta?.length > 0) {
				setInvForm((prevForm) => {
					return {
						...prevForm,
						coleta_dados: coleta[0]?.dados_coletados,
					};
				});
			}

			if (equipe?.length > 0) {
				setCounter(equipe?.length);
				setInvForm((prevForm) => {
					return {
						...prevForm,
						equipe_investigacao_data: equipe.map((membro) => ({
							nome_completo: membro.nome_completo,
							cargo: membro.cargo,
							setor: membro.setor,
							email: membro.email,
						})),
					};
				});
			}
			if (planos?.length > 0) {
				setPlanCounter(planos?.length);
				setInvForm((prevForm) => {
					return {
						...prevForm,
						plano_acoes_data: planos.map((plano) => ({
							causas_prioritarias: plano.causas_prioritarias,
							acoes_planejadas: plano.acoes_planejadas,
							responsavel: plano.responsabilidade,
							prazo: plano.prazo,
							status: plano.status,
						})),
					};
				});
			}
			if (cronologia?.length > 0) {
				setCronCounter(cronologia?.length);
				setInvForm((prevForm) => {
					return {
						...prevForm,
						cronologia_incidentes_data: cronologia.map((cron) => ({
							evento: cron.evento,
							hora: cron.hora_evento,
							data: cron.data_evento,
							setor: cron.local,
							descricao: cron.descricao,
						})),
					};
				});
			}
			if (causas?.length > 0) {
				setInvForm((prevForm) => {
					return {
						...prevForm,
						definicao_causas_data: {
							fator_paciente: causas[0].fatores_paciente,
							fator_profissional: causas[0].fatores_profissionais,
							fator_tarefa: causas[0].fatores_tarefa,
							fator_comunicacao: causas[0].fatores_comunicacao,
							fator_equipamento: causas[0].fatores_equipamento,
							fator_ambiente: causas[0].fatores_ambiente,
							fator_organizacional:
								causas[0].fatores_organizacionais,
							fator_treinamento: causas[0].fatores_treinamento,
						},
					};
				});
			}
		} else {
			setInvId(inv?.id);
		}
		setNoteId(result.id);
		setClassForm({
			classificacao: result.classificacao,
			prazo_investigacao: result.prazo_investigacao,
			sub_classificacao: result.sub_classificacao,
			notificacao: result.protocolo,
		});
	};

	useEffect(() => {
		const handleEsc = (e) => {
			if (e.key === 'Escape') setEmailAlert(false);
		};
		window.addEventListener('keydown', handleEsc);
		return () => window.removeEventListener('keydown', handleEsc);
	}, []);

	useEffect(() => {
		if (notificacao) {
			if (notificacao.status === 'NOTIFICADO') {
				setForm({
					...form,
					notificacao: notificacao.protocolo,
					unidade_token_notificacao: notificacao.token_notificacao,
					fato_presenciado: notificacao.fato_presenciado,
					quem_presenciou: notificacao.quem_presenciou,
					envolve_paciente: notificacao.envolve_paciente,
					sexo_paciente: notificacao.sexo_paciente,
					nome_paciente: notificacao.nome_paciente,
					nascimento_paciente: notificacao.nascimento_paciente,
					prontuario: notificacao.prontuario,
				});
				if (cards.caso !== cards.card) {
					return setIsButtonEnabled(false);
				}
			}
			if (notificacao.status === 'CLASSIFICADO') {
			
				perRequest();
				if (cards.caso !== cards.card) {
					return setIsButtonEnabled(false);
				}
			}
			if (notificacao.status === 'INVESTIGADO') {
				/* listInv();
				setInvForm({
					...invForm,
					notificacao: notificacao.protocolo,
				}); */
				perRequest();
				if (cards.caso !== cards.card) {
					return sendButtonEnabled(notificacao);
				} else {
					return sendButtonEnabled(notificacao);
				}
			}
			if (notificacao?.status === 'CONCLUIDO') {
				isRejected();
				if (notificacao?.classificacao?.descartar === true) {
					setForm({
						...form,
						notificacao: notificacao.protocolo,
					});
					setIsButtonEnabled(false);
				} else {
					/* listInv(); */
					listAval(invId);

					perRequest();

					const prev = finalForm;

					setFinalForm({
						...prev,
						notificacao: notificacao.protocolo,
					});

					if (
						cards.caso === 'INVESTIGADO' &&
						cards.card === 'INVESTIGADO' &&
						notificacao.status === 'CONCLUIDO'
					) {
						return setIsButtonEnabled(false);
					} else if (cards.caso !== cards.card) {
						return setIsButtonEnabled(false);
					}
				}
			}
			setForm((prevForm) => ({
				...prevForm,
				num_notificacao: notificacao.protocolo,
				data_notificacao: notificacao.data_notificacao,
				data_ocorrencia: notificacao.data_ocorrencia,
				unidade: notificacao.unidade,
				setor: notificacao.setor,
				nome_paciente: notificacao.nome_paciente,
				sexo_paciente: notificacao.sexo_paciente,
				nascimento_paciente: notificacao.nascimento_paciente,
				prontuario: notificacao.prontuario,
				notificador: notificacao.notificante,
				tipo_incidente: notificacao.tipo_incidente,
				quem_presenciou: notificacao.quem_presenciou,
				descricao_ocorrencia: notificacao.descricao,
				acoes_imediatas: notificacao.acoes_imediatas,
				medida_preventiva: notificacao.medida_preventiva,
				fato_presenciado: notificacao.fato_presenciado,
				turno: notificacao.turno,
				other_checked:
					notificacao.tipo_incidente_outros !== '' ? true : false,
			}));
		}
	}, []);

	return (
		<div className='flex flex-col min-h-screen justify-center'>
			{enviado ? (
				<div className='font-inter flex justify-center items-start w-[80%] mx-auto h-screen'>
					<div className='flex flex-col  bg-[#F5F5F5] mt-[100px]  items-center rounded-md  max-w-[800px] gap-5 flex-grow shadow-lg'>
						<div className='bg-[#004A80]  rounded-t-md  w-full h-[20px] '>
							{' '}
						</div>
						<div className='text-[#00C0F3]   '>
							<IoMdCheckmarkCircle className='size-[50px] sm:size-[100px]' />
						</div>
						<div className='sm:text-3xl font-semibold text-[#004A80]'>
							{' '}
							{notificacao?.status === 'NOTIFICADO' &&
								'Classificação feita com Sucesso'}
							{notificacao?.status === 'CLASSIFICADO' &&
								'Investigação feita com Sucesso'}
							{notificacao?.status === 'INVESTIGADO' &&
								'Notificação concluída com Sucesso'}
						</div>
						<div className='text-sm flex justify-center  text-center sm:text-lg font-medium mx-auto w-[80%] text-[#8b8b8b]'>
							{' '}
							{`A etapa foi concluída com sucesso,
							acompanhe o andamento dela através do painel de
							acompanhamento ou consultando o protocolo abaixo.`}{' '}
						</div>
						<div className='flex flex-col sm:text-4xl font-bold mt-2 sm:mt-[32px] text-[#004A80]'>
							<div className='flex gap-3'>
								<div>Protocolo: </div>
								<button
									onClick={handleCopy}
									value={notificacao?.protocolo}
									className='appearence-none'>
									{notificacao?.protocolo}
									{/* {' '}
									{Math.floor(Math.random() * 1000000)} */}
								</button>
							</div>

							{copiado ? (
								<div className='flex flex-col justify-end '>
									<div className='text-[#a0a0a0] font-semibold text-end  text-[12px]'>
										Protocolo copiado!
									</div>
								</div>
							) : null}
						</div>
						<p className='text-xs sm:text-lg mx-auto text-center sm:text-start text-[#a0a0a0] mt-4  '>
							Clique no botão abaixo para baixar o PDF da sua
							notificação
						</p>
						<button
							className='sm:w-35 flex items-center justify-center gap-2 border border-[#B74644] text-[#B74644] p-1 sm:py-2 sm:px-4 rounded-md hover:bg-[#B74644] hover:text-white transition-all duration-200 text-[10px] sm:text-base focus:outline-none cursor-pointer sm:mb-[40px]'
							onClick={() => {
								handleDownloadPDF();
								setPdfBaixado(true);
							}}>
							{pdfBaixado ? (
								'Download Concluído'
							) : (
								<>
									<FaRegFilePdf className='scale-[130%] text-[10px]' />
									Baixar PDF
								</>
							)}
						</button>

						<a
							className='text-[#00C0F3] text-[10px] sm:text-base mb-14 hover:text-[#004A80] transition-all duration-200'
							href='/hub-de-notificacoes'>
							{' '}
							voltar à consulta de protocolos
						</a>
					</div>
				</div>
			) : (
				<div
					className={`${
						formLayout ? 'px-1 w-full' : 'px-1 max-w-[100vw]'
					}`}>
					<div
						ref={formRef}
						id='my-table-id'
						className={`${
							formLayout
								? 'mx-auto  w-full max-w-[1130px] mt-10 lg:px-8 overflow-hidden'
								: 'sm:mx-auto sm:w-full w-full max-w-[100vw] sm:max-w-[1130px] sm:mt-10 sm:px-6 lg:px-8 overflow-hidden'
						}`}>
						<div id='block1'>
							<div
								className={`${
									formLayout
										? 'flex flex-row justify-between w-full h-[150px] my-1 mt-[-50px]'
										: 'flex flex-col md:flex-row justify-between w-full h-[150px] my-1'
								}`}>
								<div
									className={`${
										formLayout
											? 'w-[40%] h-[105px] my-3 flex justify-start'
											: 'w-0 md:w-[30%] h-[105px] my-3 flex justify-center md:justify-start'
									}`}>
									<img
										alt='logo da prefeitura'
										src={Logo}
										className={`${
											formLayout
												? 'h-[80%] mt-6 scale-75 object-contain'
												: 'h-full scale-75 object-contain sm:block hidden'
										}`}
									/>
								</div>
								<div
									className={`${
										formLayout
											? 'w-[65%] h-[105px] my-5 text-white font-bold text-center flex items-center justify-center'
											: 'w-full md:w-[65%] h-[105px] my-5 text-white font-bold text-center flex items-center justify-center'
									}`}>
									<p
										className={`${
											formLayout
												? 'p-0 pb-10 text-3xl bg-gray-800 h-full content-center'
												: 'sm:text-2xl py-5 px-5 md:p-0 lg:text-3xl bg-gray-800 h-full content-center'
										}`}>
										ANÁLISE E TRATAMENTO DE EVENTOS ADVERSOS
									</p>
								</div>
							</div>
							<div className='w-full border-[1px] border-black'>
								<div className='w-full'>
									<div
										className={`${
											formLayout
												? 'flex flex-row'
												: 'flex flex-col md:flex-row'
										}`}>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-4/12 mr-2 text-start content-center '>
												Notificação n.º:{' '}
											</p>
											{notificacao?.protocolo}
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-6/12 text-start content-center mr-2 '>
												Data da notificação:
											</p>
											{/* {notificacao?.data_notificacao &&
												console.log(
													notificacao?.data_notificacao
												)} */}
											{notificacao?.data_notificacao
												? formatDate(
														notificacao?.data_notificacao
												  )
												: '00/00/0000'}
										</div>

										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2  border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2  sm:border-r-[0px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-6/12 text-start content-center mr-2'>
												Data da ocorrência:
											</p>

											{formatDate(
												notificacao?.data_ocorrencia
													? notificacao?.data_ocorrencia
													: '00/00/0000'
											)}
										</div>
									</div>
									<div
										className={`${
											formLayout
												? 'flex flex-row'
												: 'flex flex-col md:flex-row'
										}`}>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-1/2 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex w-full justify-start md:w-1/2 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold content-center align-baseline py-1 mr-2'>
												Unidade:
											</p>
											<p className='mx-4 content-center'>
												{notificacao?.unidade_nome}
											</p>
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-8/12 border-b-[1px] border-r-[1px] border-black px-2 py-3'
													: 'flex w-full md:w-7/12 border-b-[1px] border-black px-2 py-3  sm:border-r-[1px]'
											}`}>
											<p className='font-semibold content-center w-6/12 py-1  '>
												Setor onde ocorreu o incidente:
											</p>
											<p className='mx-2 content-center'>
												{notificacao?.setor}
											</p>
										</div>
										<div className='flex border-b-[1px] items-center border-black px-2 py-3'>
											<p className='font-semibold  text-start py-1'>
												Turno:
											</p>
											<p className='mx-4 content-center'>
												{notificacao?.turno_display}
											</p>
										</div>
									</div>
									<div className='flex border-b-[1px] border-black px-2 py-3'>
										<p className='font-semibold  text-start py-1'>
											Nome completo do paciente:
										</p>

										<p className='mx-4 content-center'>
											{form?.envolve_paciente === false ||
											form?.nome_paciente === '' ||
											!form?.nome_paciente
												? 'Não consta'
												: form?.nome_paciente}
										</p>
									</div>
									<div
										className={`${
											formLayout
												? 'w-full flex flex-row relative'
												: 'w-full flex flex-col md:flex-row relative'
										}`}>
										{!notificacao.envolve_paciente && (
											<div className='absolute bg-white opacity-[60%] h-full w-full'></div>
										)}
										<div
											className={`${
												formLayout
													? 'flex xs:w-1/4 border-r-[1px] border-b-[1px] border-black px-2 py-3'
													: 'flex xs:w-1/4 sm:border-r-[1px] border-b-[1px] border-black px-2 py-3 '
											}`}>
											<p className='font-semibold text-start mr-3 content-center'>
												Sexo:
											</p>
											<div className='flex  gap-4 '>
												<label className='flex items-end py-1 '>
													<input
														type='radio'
														name='sexo_paciente'
														id='masculino'
														checked={
															form?.envolve_paciente
																? form?.sexo_paciente ===
																  'M'
																: false
														}
														{...(form?.status ===
															'NOTIFICADO' &&
															'readOnly')}
														className=' h-4 w-4 text-blue-600'
													/>
													<span className='ml-2 text-sm'>
														Masculino
													</span>
												</label>
												<label className='flex items-end py-1'>
													<input
														type='radio'
														name='sexo_paciente'
														id='feminino'
														checked={
															form?.envolve_paciente
																? form?.sexo_paciente ===
																  'F'
																: false
														}
														{...(form?.status ===
															'NOTIFICADO' &&
															'readOnly')}
														className=' h-4 w-4 text-blue-600'
													/>
													<span className='ml-2 text-sm'>
														Feminino
													</span>
												</label>
											</div>
										</div>
										<div
											className={`${
												formLayout
													? 'flex w-full justify-start md:w-5/12  border-b-[1px] border-black  px-2 py-3'
													: 'flex w-full justify-start md:w-5/12  border-b-[1px] border-black px-2 py-3'
											}`}>
											<p className='font-semibold w-7/12 text-start content-center'>
												Data de Nascimento:
											</p>
											<p className='content-center'>
												{' '}
												{form?.envolve_paciente
													? form?.nascimento_paciente ===
													  ''
														? formatDate(
																form?.nascimento_paciente
																	? form?.nascimento_paciente
																	: '00/00/0000'
														  )
														: formatDate(
																form?.nascimento_paciente
																	? form?.nascimento_paciente
																	: '00/00/0000'
														  )
													: ''}
											</p>
										</div>
										<div className='flex w-full md:w-2/3 sm:border-l border-b-[1px] border-black px-2 py-3'>
											<p className='font-semibold content-center py-1'>
												Prontuário/BE:
											</p>
											<p className='mx-4 content-center flex flex-grow w-[80%]'>
												{form?.envolve_paciente &&
													form?.prontuario}
											</p>
											{/* <input
												name='prontuario'
												id='prontuario'
												onChange={({
													target: { value, id },
												}) => handleForm(value, id)}
												className=' ml-2 w-full focus:outline-none'
												type='text'
											/> */}
										</div>
									</div>
									<div
										className={`${
											formLayout
												? 'flex w-full  border-black px-2 py-3'
												: 'flex w-full md:w-full  border-black px-2 py-3'
										}`}>
										<p
											className={`${
												formLayout
													? 'font-semibold content-center text-start py-1 w-[300px]'
													: 'font-semibold content-center text-start py-1 sm:w-[300px]'
											}`}>
											Identificação do notificador
											(opcional):
										</p>
										<p className='content-center mx-4'>
											{' '}
											{notificacao?.notificante === ''
												? 'Não consta'
												: notificacao?.notificante}
										</p>
									</div>
								</div>
							</div>

							<div className='w-full my-5 border-[1px] border-black'>
								<div className='w-full bg-gray-300 py-2 text-center font-bold'>
									INCIDENTES E NÃO CONFORMIDADES
								</div>
								<div className='w-full border-b-[1px] border-t border-black p-4'>
									<div
										className={`${
											formLayout
												? 'grid grid-cols-2 gap-4'
												: 'grid grid-cols-1 lg:grid-cols-2 gap-4'
										}`}>
										{tiposIncidentes.map(
											(incident, index) => (
												<label
													key={index + 'b'}
													className='flex items-center sm:whitespace-nowrap'>
													<input
														type='radio'
														name='tipo_incidente'
														checked={
															incident.value ===
															notificacao?.tipo_incidente
														}
														value={incident.display}
														id={incident.display}
														className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
													/>
													<span
														className={`${
															formLayout
																? 'ml-2 text-gray-700 mb-2 text-base'
																: 'ml-2 text-gray-700 text-sm md:text-base '
														}`}>
														{incident.display}
													</span>
												</label>
											)
										)}
										<label className='flex items-center whitespace-nowrap'>
											<input
												type='radio'
												name='tipo_incidente'
												checked={
													notificacao?.tipo_incidente ===
													'OUTROS'
												}
												className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
											/>
											<span className='ml-2 text-gray-700 flex items-center w-10/12 text-sm md:text-base'>
												Outro:
												{notificacao
													?.tipo_incidente_outros
													?.length > 0 ? (
													<div
														type='text'
														name='tipo_incidente'
														className={`ml-2 h-6 text-xs md:text-sm border-b-[1px] border-gray-500 focus:outline-none ${
															!formLayout
																? 'max-w-[300px] overflow-x-scroll sm:overflow-visible whitespace-nowrap'
																: ''
														} sm:max-w-full`}>
														{
															notificacao?.tipo_incidente_outros
														}
													</div>
												) : null}
											</span>
										</label>
									</div>
								</div>
								<div className='flex w-full py-2 flex-col sm:flex-row'>
									<p
										className={`font-semibold px-2 content-center text-start ${
											formLayout
												? 'w-full sm:w-5/12 text-sm sm:text-base'
												: 'w-full sm:md:w-5/12 text-[12px] mb-2 sm:mb-0 sm:text-xs md:text-sm'
										}`}>
										O fato foi presenciado por alguém?
									</p>

									<div className='w-full flex flex-col sm:flex-row items-start sm:items-center px-2  sm:gap-4'>
										<label className='flex items-center text-xs sm:text-sm'>
											<input
												type='radio'
												name='quem_presenciou'
												id='ninguem'
												checked={
													!notificacao?.quem_presenciou &&
													!form?.quem_presenciou
												}
												className='form-radio h-3 w-3 sm:h-4 sm:w-4 text-blue-600'
											/>
											<span
												className={`ml-2 text-gray-700 ${
													formLayout ? 'mb-1' : ''
												} text-xs sm:text-sm`}>
												Não
											</span>
										</label>
										<label className='flex items-center w-full font-semibold text-xs sm:text-sm'>
											<input
												type='radio'
												name='quem_presenciou'
												id='sim'
												checked={
													!!notificacao?.quem_presenciou ||
													!!form?.quem_presenciou
												}
												className='form-radio h-3 w-3 sm:h-4 sm:w-4 text-blue-600'
											/>
											<span className='ml-2 text-gray-700 flex w-full items-center'>
												<span
													className={`text-gray-700 text-xs sm:text-sm ${
														formLayout
															? 'w-4/12 text-start py-1'
															: 'md:w-3/12 text-start py-1'
													}`}>
													Sim?
												</span>
												{notificacao?.quem_presenciou ||
												form?.quem_presenciou ? (
													<p
														id='quem_presenciou'
														className={`w-full h-[20px] text-xs sm:text-sm ${
															formLayout
																? ''
																: 'border-b-[1px] ml-3 sm:ml-0 border-gray-500'
														} focus:outline-none`}>
														{notificacao?.quem_presenciou ||
															form?.quem_presenciou}
													</p>
												) : null}
											</span>
										</label>
									</div>
								</div>
							</div>
							<div className='w-full my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Descrição da ocorrência.
								</div>
								<div
									name='descricao_ocorrencia'
									id='descricao_ocorrencia'
									className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'>
									{' '}
									{notificacao?.descricao}
								</div>
							</div>
							<div className='w-full my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Ações imediatas tomadas.
								</div>
								<div
									name='acoes_imediatas'
									id='acoes_imediatas'
									className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'>
									{notificacao?.acoes_imediatas}
								</div>
							</div>
							<div className='w-full my-5 border-[1px] border-black'>
								<div className='text-start px-2 font-semibold'>
									Existe alguma medida em vigor para prevenir
									tal incidente? Qual?
								</div>
								<div
									name='medida_preventiva'
									id='medida_preventiva'
									className='w-full h-36 mt-2 px-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'>
									{notificacao?.medida_preventiva}
								</div>
							</div>
						</div>

						<div id='block2'>
							{((notificacao?.status === 'NOTIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'CLASSIFICADO' ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div
									className={`${
										formLayout
											? 'w-full my-5 border-[1px] mb-10  border-black'
											: 'w-full my-5 border-[1px]  border-black'
									}`}>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										CLASSIFICAÇÃO INCIDENTE
									</div>
									<div className='w-full p-2'>
										<div className='flex flex-col gap-2 mt-2'>
											{classificacoes.map((evento) => (
												<div
													key={evento.display + 'c'}
													className={`flex items-start gap-2`}>
													<input
														type='radio'
														name='opcao'
														id='classificacao'
														checked={
															notificacao?.status ===
															'NOTIFICADO'
																? undefined
																: classForm.classificacao ===
																  evento.display
														}
														value={evento.display}
														className={`${
															formLayout
																? 'mt-[10px]'
																: 'mt-[4px]'
														}`}
														onChange={
															notificacao?.status ===
															'NOTIFICADO'
																? handleClassForm
																: null
														}
													/>
													<label
														htmlFor={evento.display}
														className={`${
															formLayout
																? 'flex gap-2 mb-2'
																: 'flex gap-2'
														}`}>
														<p className='text-sm font-normal content-center'>
															<span className='font-bold'>
																{evento.value}:
															</span>{' '}
															{evento.descricao}
														</p>
													</label>
												</div>
											))}

											<div className='flex items-start gap-2'>
												<input
													type='radio'
													name='opcao'
													id='classificacao'
													onChange={handleClassForm}
													checked={
														notificacao?.status ===
														'NOTIFICADO'
															? undefined
															: classForm.classificacao ===
															  'NEVER_EVENTS'
													}
													value='NEVER_EVENTS'
													className='mt-[4px]'
												/>
												<label
													htmlFor='never'
													className={`${
														formLayout
															? 'flex gap-2'
															: 'flex gap-2'
													}`}>
													<div className='text-sm font-normal content-center flex gap-2'>
														<span className='font-bold'>
															Never Events:
														</span>{' '}
														{notificacao?.status ===
														'NOTIFICADO' ? (
															<div>
																{formLayout ? (
																	<div>
																		{classForm.sub_classificacao ===
																		''
																			? 'Nenhum Never Event'
																			: classForm.sub_classificacao}
																	</div>
																) : (
																	<select
																		className='w-[290px] bg-[#f0f0f0] p-1 rounded-md  '
																		value={
																			notificacao
																				?.classificacao
																				?.classificacao ===
																			'NEVER_EVENTS'
																				? notificacao
																						?.classificacao
																						?.sub_classificacao
																				: classForm.sub_classificacao
																		}
																		id='sub_classificacao'
																		onChange={
																			handleClassForm
																		}>
																		<option
																			value=''
																			className=''>
																			Escolha
																			um
																			valor
																			de
																			acordo
																			com
																			o
																			evento
																		</option>
																		{NeverJson.map(
																			(
																				item,
																				index
																			) => (
																				<option
																					key={
																						index +
																						'g'
																					}
																					id='sub_classificacao'
																					value={
																						item.codigo
																					}
																					className='flex mb-10'>
																					{item.codigo +
																						' ' +
																						item.descricao}
																				</option>
																			)
																		)}
																	</select>
																)}{' '}
															</div>
														) : (
															<p className=''>
																{classForm?.sub_classificacao ===
																''
																	? 'Nenhum Never Event'
																	: NeverJson.find(
																			(
																				event
																			) =>
																				event.codigo ===
																				classForm?.sub_classificacao
																	  )
																			?.descricao}
															</p>
														)}
													</div>
												</label>
											</div>
										</div>
									</div>
								</div>
							) : null}
							{((notificacao?.status === 'NOTIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'CLASSIFICADO' ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div
									className={`${
										formLayout
											? 'w-full my-5 mt-10 border-[1px]  border-black'
											: 'w-full my-5 border-[1px]  border-black'
									}`}>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold '
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										ANÁLISE DO INCIDENTE
										<p
											className={`${
												formLayout ? 'mb-4' : ''
											}`}>
											{
												'(preenchimento pelo Núcleo de Segurança do Paciente)'
											}
										</p>
									</div>

									<div
										className={`${
											formLayout
												? 'w-full p-2 flex gap-6 mb-2'
												: 'w-full p-2 flex gap-6'
										}`}>
										<p className='text-[12px] sm:text-[16px]'>
											Prazo máximo para que ocorra a
											investigação:{' '}
										</p>
										{notificacao.status !== 'NOTIFICADO' ? (
											<div>
												{classForm.prazo_investigacao
													? formatDate(
															classForm.prazo_investigacao
													  )
													: '00/00/0000'}
											</div>
										) : (
											<div className='flex gap-5'>
												{classForm.classificacao ===
													'GRAVE' ||
												classForm.classificacao ===
													'OBITO' ||
												(classForm.classificacao ===
													'NEVER_EVENTS' &&
													classForm.sub_classificacao
														.length > 0) ? (
													<p>
														{
															classForm.prazo_investigacao
														}
													</p>
												) : (
													<input
														type='date'
														id='prazo_investigacao'
														value={
															classForm.prazo_investigacao
														}
														onChange={
															handleClassForm
														}
													/>
												)}

												{validDate ? (
													<p className='text-red-600 font-medium  font-inter text-[10px]  sm:text-[12px] content-center'>
														data inválida (a data
														deve ser posterior a
														data atual)
													</p>
												) : null}
											</div>
										)}
									</div>
								</div>
							) : null}
							{/* {console.log(
								((notificacao?.status === 'CLASSIFICADO' &&
									cards.card === cards.caso) ||
									notificacao?.status === 'INVESTIGADO' ||
									notificacao?.status === 'CONCLUIDO') &&
									notificacao?.classificacao?.descartar !== true &&
									notificacao?.permissao === true
							) } */}
							{/* 	{console.log(notificacao)} */}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							notificacao?.permissao === true &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px] mb-10 border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										EQUIPE DE INVESTIGAÇÃO
										{/* 	<input
										type='text'
										id='exampleInput'
										name='example'
										defaultValue='Texto inicial'
										className='w-full text-base leading-8'
									/> */}
									</div>
									<div className='grid'>
										<div className='h-[30px] w-full flex'>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center sm:text-base text-[10px]'
												}`}>
												NOME COMPLETO
											</div>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] sm:text-base text-[10px] border-r-black  text-center '
												}`}>
												CARGO
											</div>
											<div
												className={`${
													formLayout
														? 'w-full content-center h-[full] font-semibold border-[1px] border-r-black  text-center pb-4'
														: 'w-full content-center h-[full] font-semibold border-[1px] sm:text-base text-[10px] border-r-black  text-center '
												}`}>
												SETOR
											</div>
											<div
												className={`${
													formLayout
														? 'w-full h-[full] border-[1px]  font-semibold content-center text-center pb-4 '
														: 'w-full h-[full] border-[1px]  font-semibold content-center text-center sm:text-base text-[10px] '
												}`}>
												E-MAIL
											</div>
										</div>
									</div>

									{Array.from('x'.repeat(counter)).map(
										(item, index) => (
											<div
												key={index + 'per'}
												id={index + 'cron'}
												className='grid'>
												<div className='min-h-[30px] min-w-[50px] h-auto w-full flex'>
													<div className='w-full content-center h-[full] font-semibold border-[1px]  border-r-black   text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] sm:text-[14px] text-[10px] pb-3 overflow-x-auto text-wrap font-normal'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																	  ][index][
																			'nome_completo'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	]
																		.nome_completo
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='nome_completo'
																className='text-base leading-8 sm:w-[95%] w-full h-full sm:m-2 sm:px-0 px-1 sm:h-fit font-normal'
																onChange={(e) =>
																	handleEquipe(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-full  min-w-[50px] h-[full] border-[1px] border-r-black font-semibold content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] pb-3  overflow-x-auto text-wrap sm:text-[14px] text-[10px] font-normal'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																	  ][index][
																			'cargo'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].cargo
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='cargo'
																className='text-base leading-8 sm:w-[95%] w-full sm:h-fit h-full sm:px-0 px-1 sm:m-2 font-normal'
																onChange={(e) =>
																	handleEquipe(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-full min-w-[50px] h-[full] border-[1px] border-r-black font-semibold  content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] pb-3 overflow-x-auto text-wrap sm:text-[14px] text-[10px] font-normal'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																	  ][index][
																			'setor'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].setor
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'equipe_investigacao_data'
																}
																name='setor'
																className='font-normal sm:px-0 px-1 leading-8 sm:w-[95%] w-full h-full sm:m-2 sm:h-fit'
																onChange={(e) =>
																	handleEquipe(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-full min-w-[50px]  border-[1px]  font-semibold content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] pb-3   p-2 h-auto overflow-x-auto sm:text-[14px] text-[10px] font-normal'>
																{invForm[
																	'equipe_investigacao_data'
																]
																	? invForm[
																			'equipe_investigacao_data'
																	  ][index][
																			'email'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.equipe_investigacao_data[
																		index
																	].email
																}
																type='email'
																id={`${index} / equipe_investigacao_data`}
																name='email'
																className='text-base leading-8 w-[95%] font-normal'
																onBlur={(e) => {
																	const email =
																		e.target
																			.value;
																	const emailRegex =
																		/^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex para validar email
																	if (
																		!emailRegex.test(
																			email
																		)
																	) {
																		setEmailAlert(
																			true
																		);
																	} else {
																		handleEquipe(
																			e
																				.target
																				.id,
																			e
																				.target
																				.name,
																			email
																		);
																	}
																}}
															/>
														)}
													</div>
												</div>
											</div>
										)
									)}
									{emailAlert ? (
										<div
											className='fixed inset-0 flex items-center justify-center bg-black/50 z-50 '
											onClick={() =>
												setEmailAlert(false)
											}>
											<div
												className='shadow-lg flex flex-col text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4 rounded-xl'
												onClick={(e) =>
													e.stopPropagation()
												}>
												<div className=''></div>
												<>
													<p className='text-[#a3a3a3] ont text-xl'>
														Email incorreto,
														preencha o campo
														corretamente
													</p>
													<div className='w-full text-[#bd3434] flex justify-center scale-[300%]'>
														<MdOutlineDoNotDisturbAlt />
													</div>
												</>
											</div>
										</div>
									) : null}
									{notificacao?.status === 'CLASSIFICADO' ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#525252] text-[#9e9e9e] rounded px-1 shadow-md'
												}`}
												id='adcionar'
												onClick={(e) => {
													addEquipe(e.target.id);
												}}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#525252] text-[#9e9e9e] rounded px-1 shadow-md ml-20'
												}`}
												id='remover'
												onClick={(e) => {
													addEquipe(e.target.id);
												}}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}

							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							notificacao?.permissao === true &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px]  border-black'>
									<div className='w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'>
										COLETA E ORGANIZAÇÃO DOS DADOS
										<p
											className={`${
												formLayout
													? 'text-sm pb-4'
													: 'text-sm'
											}`}>
											{
												'(usar metodologia apropriada - entrevistas, consula a prontuários ou documentos que a instituição possua, busca ativa em campo, entre outros)'
											}
										</p>
									</div>

									{notificacao?.status === 'CLASSIFICADO' ? (
										<textarea
											id='coleta_dados'
											defaultValue={invForm.coleta_dados}
											className='p-2 w-full h-36 mt-2 text-md text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'
											placeholder='Definição do cenário:'
											type='text'
											name='coleta_dados'
											onChange={(e) =>
												handleColeta(
													e.target.id,

													e.target.name,

													e.target.value
												)
											}></textarea>
									) : (
										<div className='p-4 w-full h-full'>
											{invForm.coleta_dados}
										</div>
									)}
								</div>
							) : null}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							notificacao?.permissao === true &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px] mb-10 border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										CRONOLOGIA DO INCIDENTE
									</div>
									<div className='grid'>
										<div className='h-[30px] w-full content-center flex'>
											<div className='w-7/12 content-center   font-semibold border-[1px] sm:pb-4 border-r-black  text-center sm:text-base text-[10px] h-full  '>
												EVENTO
											</div>
											<div className='w-5/12 h-full border-[1px] border-r-black font-semibold sm:pb-4 content-center text-center sm:text-base text-[10px] '>
												DATA
											</div>
											<div className='w-4/12 h-full border-[1px] border-r-black font-semibold sm:pb-4 content-center text-center sm:text-base text-[10px] '>
												HORA
											</div>
											<div className='w-6/12 h-full border-[1px]  font-semibold border-r-black sm:pb-4 content-center text-center sm:text-base text-[10px] '>
												LOCAL/SETOR
											</div>
											<div className='w-full h-full border-[1px]  font-semibold content-center sm:pb-4 text-center sm:text-base text-[10px] '>
												DESCRIÇÃO
											</div>
										</div>
									</div>
									<div></div>
									{Array.from({ length: cronCounter }).map(
										(_, index) => (
											<div
												key={`${index}-${'australopitecus'}`}
												className='grid'>
												<div className='min-h-[30px] h-auto w-full flex'>
													<div className=' w-7/12 content-center h-[full]  border-[1px] border-r-black min-w-[50px] text-center'>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[200px] sm:text-[14px] text-[10px] overflow-x-auto text-wrap pb-3 font-normal'>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																	  ][index][
																			'evento'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].evento
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='evento'
																className='text-base px-2 leading-8 sm:w-[100%] w-[100%] font-normal'
																onChange={(e) =>
																	handleCronologia(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className=' w-5/12  min-w-[50px]  h-[full] border-[1px] border-r-black  font-semibold content-center text-center'>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] overflow-x-auto text-wrap pb-3 sm:text-[14px] text-[10px] font-normal'>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? formatDate(
																			invForm[
																				'cronologia_incidentes_data'
																			][
																				index
																			][
																				'data'
																			]
																	  )
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].data
																}
																type='date'
																max={
																	new Date()
																		.toISOString()
																		.split(
																			'T'
																		)[0]
																} // Define o limite máximo como hoje
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='data'
																className=' leading-8 sm:w-[95%]  font-normal sm:max-w-[95%] max-w-[52px] '
																onChange={(e) =>
																	handleCronologia(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-4/12 min-w-[45px]  h-[full] border-[1px] border-r-black font-semibold content-center text-center'>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] sm:text-[14px] text-[10px] pb-3 text-wrap font-normal overflow-x-auto'>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																	  ][index][
																			'hora'
																	  ]
																			.split(
																				':'
																			)
																			.slice(
																				0,
																				2
																			)
																			.join(
																				':'
																			)
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].hora
																}
																type='time'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='hora'
																className='text-base leading-8 w-[100%] sm:w-[60%] font-normal'
																onChange={(e) =>
																	handleCronologia(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-6/12 min-w-[50px] h-[full] border-[1px] font-semibold content-center border-r-black text-center'>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='max-w-[260px] sm:text-[14px] text-[10px] pb-3 text-wrap font-normal overflow-x-auto'>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																	  ][index][
																			'setor'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		.cronologia_incidentes_data[
																		index
																	].setor
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																name='setor'
																className='text-base leading-8 w-[95%] font-normal'
																onChange={(e) =>
																	handleCronologia(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-full min-w-[50px] h-[full] border-[1px] font-semibold content-center text-center'>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full pb-3 sm:text-[14px] text-[10px] overflow-x-auto p-2 text-wrap font-normal'>
																{invForm[
																	'cronologia_incidentes_data'
																]
																	? invForm[
																			'cronologia_incidentes_data'
																	  ][index][
																			'descricao'
																	  ]
																	: null}
															</div>
														) : (
															<input
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'cronologia_incidentes_data'
																}
																placeholder='no mínimo 10 caracteres'
																name='descricao'
																defaultValue={
																	invForm
																		?.cronologia_incidentes_data[
																		index
																	]?.descricao
																}
																className='text-base leading-8 w-[100%] sm:w-[95%] font-normal'
																onChange={(e) =>
																	handleCronologia(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
												</div>
											</div>
										)
									)}
									{notificacao?.status === 'CLASSIFICADO' ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#525252] text-[#9e9e9e] rounded px-1 shadow-md'
												}`}
												id='adcionar'
												onClick={(e) => {
													addCronologia(e.target.id);
												}}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												key={'sla'}
												id='remover'
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#6d6d6d] text-[#9e9e9e] rounded px-1 shadow-md ml-20'
												}`}
												onClick={(e) => {
													addCronologia(e.target.id);
												}}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							notificacao?.permissao === true &&
							concluido === false ? (
								<div className='w-full mt-5 border-[1px] border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										DEFINIÇÃO DAS CAUSAS — FATORES QUE
										CONTRIBUÍRAM PARA O INCIDENTE
									</div>
									{/* <div className='w-full px-2  py-1 border-black border-b-2 text-start text-sm font-bold'>
								INCIDENTE :
							</div> */}
									<div className='grid'>
										<div className='min-h-[45px] h-auto w-full flex text-[10px] sm:text-[13px]'>
											<div className='w-full content-center h-[full] font-bold border-[1px] border-r-black  sm:pb-4 py-1  text-center '>
												FATORES DO PACIENTE
											</div>
											<div className='w-full h-[full] border-[1px] border-r-black font-bold content-center  py-1 text-center '>
												FATORES INDIVIDUAIS DOS
												PROFISSIONAIS
											</div>
											<div className='w-full h-[full] border-[1px] border-r-black font-bold content-center  py-1 text-center '>
												FATORES INDIVIDUAIS DA TAREFA OU
												ATIVIDADE
											</div>
											<div className='w-full h-[full] border-[1px]  font-bold border-r-transparent  py-1 content-center text-center '>
												FATORES RELACIONADOS A
												COMUNICAÇÃO
											</div>
										</div>
									</div>
									{Array.from(
										'x'.repeat(incident1Counter)
									).map((item, index) => (
										<div className='grid '>
											<div className='h-auto min-h-[45px]  w-full flex text-[11px] sm:text-[16px] font-semibold'>
												<div className='w-full content-center h-[full]  border-[1px] border-r-black  text-center '>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ? (
														<div className='w-full p-2 py-5  text-wrap font-normal'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																  ][
																		'fator_paciente'
																  ]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_paciente
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_paciente'
															className='appearance-none  text-base leading-8 w-[95%] font-normal'
															onChange={(e) =>
																handleCausas(
																	e.target.id,

																	e.target
																		.name,

																	e.target
																		.value
																)
															}></input>
													)}
												</div>
												<div className='w-full h-[full] border-[1px] font-semibold border-r-black  content-center text-center '>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ? (
														<div className='w-full p-2 py-5  text-wrap font-normal'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																  ][
																		'fator_profissional'
																  ]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_profissional
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_profissional'
															className='appearance-none  text-base leading-8 w-[95%] font-normal'
															onChange={(e) =>
																handleCausas(
																	e.target.id,

																	e.target
																		.name,

																	e.target
																		.value
																)
															}></input>
													)}
												</div>
												<div className='w-full h-[full] border-[1px] border-r-black font-semibold  content-center text-center '>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ? (
														<div className='w-full p-2 py-5  font-normal  text-wrap'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																  ][
																		'fator_tarefa'
																  ]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_tarefa
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_tarefa'
															className='appearance-none  text-base leading-8 w-[95%] font-normal'
															onChange={(e) =>
																handleCausas(
																	e.target.id,

																	e.target
																		.name,

																	e.target
																		.value
																)
															}></input>
													)}
												</div>
												<div className='w-full h-[full] border-[1px]  font-semibold border-r-transparent content-center text-center '>
													{notificacao?.status ===
														'INVESTIGADO' ||
													notificacao?.status ===
														'CONCLUIDO' ? (
														<div className='w-full p-2 py-5 text-wrap font-normal'>
															{invForm[
																'definicao_causas_data'
															]
																? invForm[
																		'definicao_causas_data'
																  ][
																		'fator_comunicacao'
																  ]
																: null}
														</div>
													) : (
														<input
															defaultValue={
																invForm
																	?.definicao_causas_data
																	.fator_comunicacao
															}
															type='text'
															id={
																index +
																' ' +
																'/' +
																' ' +
																'definicao_causas_data'
															}
															name='fator_comunicacao'
															className='appearance-none  text-base leading-8 w-[95%] font-normal'
															onChange={(e) =>
																handleCausas(
																	e.target.id,

																	e.target
																		.name,

																	e.target
																		.value
																)
															}></input>
													)}
												</div>
											</div>
										</div>
									))}
									<div className='grid '>
										<div className='min-h-[45px] h-auto w-full flex text-[10px] sm:text-[13px]'>
											<div className='w-full  content-center h-[full] font-bold border-[1px] border-r-black border-t-black  text-center  sm:pb-4 py-1'>
												FATORES RELACIONADOS A
												EQUIPAMENTOS
											</div>
											<div className='w-full h-[full] border-[1px]  font-bold content-center text-center sm:pb-4 py-1 border-r-black border-t-black'>
												FATORES RELACIONADOS AO AMBIENTE
												DE TRABALHO
											</div>
											<div className='w-full h-[full] border-[1px] font-bold content-center text-center border-r-black border-t-black sm:pb-4 py-1'>
												FATORES ORGANIZACIONAIS
											</div>
											<div className='w-full h-[full] border-[1px]  font-bold content-center text-center sm:pb-4 py-1  border-t-black'>
												FATORES RELACIONADOS A
												TREINAMENTO E EDUCAÇÃO
											</div>
										</div>
										<div>
											{Array.from(
												'x'.repeat(incident1Counter)
											).map((item, index) => (
												<div className='grid'>
													<div
														className={`min-h-[45px] h-auto  w-full flex text-[11px] sm:text-[16px]`}>
														<div
															className={`w-full content-center    h-[full] font-semibold border-b-transparent border-[1px] border-r-black  text-center  ${
																index ===
																incident1Counter -
																	1
																	? 'border-b-black'
																	: ''
															} `}>
															{notificacao?.status ===
																'INVESTIGADO' ||
															notificacao?.status ===
																'CONCLUIDO' ? (
																<div className='w-full p-2 py-5 text-wrap font-normal'>
																	{invForm[
																		'definicao_causas_data'
																	]
																		? invForm[
																				'definicao_causas_data'
																		  ][
																				'fator_equipamento'
																		  ]
																		: null}
																</div>
															) : (
																<input
																	defaultValue={
																		invForm
																			?.definicao_causas_data
																			.fator_equipamento
																	}
																	type='text'
																	id={
																		index +
																		' ' +
																		'/' +
																		' ' +
																		'definicao_causas_data'
																	}
																	name='fator_equipamento'
																	className='appearance-none  text-base leading-8 w-[95%] font-normal'
																	onChange={(
																		e
																	) =>
																		handleCausas(
																			e
																				.target
																				.id,

																			e
																				.target
																				.name,

																			e
																				.target
																				.value
																		)
																	}></input>
															)}
														</div>
														<div
															className={`w-full h-[full] border-[1px] border-r-black font-semibold content-center text-center border-b-transparent ${
																index ===
																incident1Counter -
																	1
																	? 'border-b-black'
																	: ''
															} `}>
															{notificacao?.status ===
																'INVESTIGADO' ||
															notificacao?.status ===
																'CONCLUIDO' ? (
																<div className='w-full p-2 text-wrap font-normal'>
																	{invForm[
																		'definicao_causas_data'
																	]
																		? invForm[
																				'definicao_causas_data'
																		  ][
																				'fator_ambiente'
																		  ]
																		: null}
																</div>
															) : (
																<input
																	defaultValue={
																		invForm
																			?.definicao_causas_data
																			.fator_ambiente
																	}
																	type='text'
																	id={
																		index +
																		' ' +
																		'/' +
																		' ' +
																		'definicao_causas_data'
																	}
																	name='fator_ambiente'
																	className='appearance-none  text-base leading-8 w-[95%] font-normal'
																	onChange={(
																		e
																	) =>
																		handleCausas(
																			e
																				.target
																				.id,

																			e
																				.target
																				.name,

																			e
																				.target
																				.value
																		)
																	}></input>
															)}
														</div>
														<div
															className={`w-full h-[full] border-[1px] border-r-black border-b-transparent font-semibold content-center text-center  ${
																index ===
																incident1Counter -
																	1
																	? 'border-b-black'
																	: ''
															} `}>
															{notificacao?.status ===
																'INVESTIGADO' ||
															notificacao?.status ===
																'CONCLUIDO' ? (
																<div className='w-full p-2 text-wrap font-normal'>
																	{invForm[
																		'definicao_causas_data'
																	]
																		? invForm[
																				'definicao_causas_data'
																		  ][
																				'fator_organizacional'
																		  ]
																		: null}
																</div>
															) : (
																<input
																	defaultValue={
																		invForm
																			?.definicao_causas_data
																			.fator_organizacional
																	}
																	type='text'
																	id={
																		index +
																		' ' +
																		'/' +
																		' ' +
																		'definicao_causas_data'
																	}
																	name='fator_organizacional'
																	className='appearance-none  text-base leading-8 w-[95%] font-normal'
																	onChange={(
																		e
																	) =>
																		handleCausas(
																			e
																				.target
																				.id,

																			e
																				.target
																				.name,

																			e
																				.target
																				.value
																		)
																	}></input>
															)}
														</div>
														<div
															className={`w-full h-[full] border-[1px] border-b-transparent font-semibold  content-center  text-center ${
																index ===
																incident1Counter -
																	1
																	? 'border-b-black'
																	: ''
															} `}>
															{notificacao?.status ===
																'INVESTIGADO' ||
															notificacao?.status ===
																'CONCLUIDO' ? (
																<div className='w-full p-2 text-wrap font-normal'>
																	{invForm[
																		'definicao_causas_data'
																	]
																		? invForm[
																				'definicao_causas_data'
																		  ][
																				'fator_treinamento'
																		  ]
																		: null}
																</div>
															) : (
																<input
																	defaultValue={
																		invForm
																			?.definicao_causas_data
																			.fator_treinamento
																	}
																	type='text'
																	id={
																		index +
																		' ' +
																		'/' +
																		' ' +
																		'definicao_causas_data'
																	}
																	name='fator_treinamento'
																	className='appearance-none  text-base leading-8 w-[95%] font-normal'
																	onChange={(
																		e
																	) =>
																		handleCausas(
																			e
																				.target
																				.id,

																			e
																				.target
																				.name,

																			e
																				.target
																				.value
																		)
																	}></input>
															)}
														</div>
													</div>
												</div>
											))}
										</div>
									</div>
									{/* <button
								className='absolute font-bold text-[14px] hover:text-[#666666]'
								onClick={() =>
									incident1Counter
										? setIncident1Counter(
												incident1Counter + 1
										  )
										: null
								}>
								{' '}
								Adicionar{' '}
							</button>
							<button
								className='absolute font-bold text-[14px] ml-20  hover:text-[#666666]'
								onClick={() =>
									incident1Counter > 1
										? setIncident1Counter(
												incident1Counter - 1
										  )
										: null
								}>
								{' '}
								Remover{' '}
							</button> */}
								</div>
							) : null}

							{/* {notificacao?.status !== 'CLASSIFICADO' ? null : (
						<div>
							<button
								className='absolute font-bold text-[14px] hover:text-[#666666]'
								onClick={() =>
									incident1Counter
										? setIncident1Counter(
												incident1Counter + 1
										  )
										: null
								}>
								{' '}
								Adicionar{' '}
							</button>
							<button
								className='absolute font-bold text-[14px] ml-20  hover:text-[#666666]'
								onClick={() =>
									incident1Counter > 1
										? setIncident1Counter(
												incident1Counter - 1
										  )
										: null
								}>
								{' '}
								Remover{' '}
							</button>
						</div>
					)} */}
							{((notificacao?.status === 'CLASSIFICADO' &&
								cards.card === cards.caso) ||
								notificacao?.status === 'INVESTIGADO' ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							notificacao?.permissao === true &&
							concluido === false ? (
								<div className='w-full my-10 border-[1px] mb-10  border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-2 text-center font-bold'
										}`}>
										PLANO DE AÇÃO
									</div>

									<div className='grid'>
										<div className='h-[30px] w-full flex'>
											<div className='w-full content-center h-[full] font-semibold border-[1px] border-r-black sm:text-[14px] text-[9px] sm:pb-4 text-center '>
												CAUSAS PRIORITÁRIAS
											</div>
											<div className='w-full h-[full] border-[1px] border-r-black font-semibold sm:pb-4 content-center text-center sm:text-[14px] text-[9px]'>
												AÇÕES PLANEJADAS
											</div>
											<div className='w-full break-all h-[full] border-[1px] border-r-black font-semibold sm:pb-4 content-center text-center sm:text-[14px] text-[9px]'>
												RESPONSABILIDADE
											</div>
											<div className='w-full h-[full] border-[1px]  font-semibold border-r-black sm:pb-4 content-center text-center sm:text-[14px] text-[9px]'>
												PRAZO
											</div>
											<div className='w-full h-[full] border-[1px]  font-semibold content-center sm:pb-4 text-center sm:text-[14px] text-[9px]'>
												STATUS
											</div>
										</div>
									</div>

									{Array.from('x'.repeat(planCounter)).map(
										(item, index) => (
											<div className='grid'>
												<div className='h-auto min-h-[45px] w-full flex'>
													<div className='sm:w-full w-full content-center h-[full] font-semibold border-r-[1px] border-r-black overflow-x-auto text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full p-2 sm:text-[14px] text-[8px] text-wrap font-normal sm-text-[14px] '>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																	  ][index][
																			'causas_prioritarias'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.causas_prioritarias
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='causas_prioritarias'
																className='appearance-none text-base leading-8 w-[95%] font-normal'
																onChange={(e) =>
																	handlePlano(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='sm:w-full  w-full  h-[full] border-r-[1px] border-r-black  content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full sm:text-[14px] text-[8px] overflow-x-auto p-2 text-wrap font-normal words-break-all'>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																	  ][index][
																			'acoes_planejadas'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.acoes_planejadas
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='acoes_planejadas'
																className='appearance-none   text-base leading-8 w-[95%] font-normal'
																onChange={(e) =>
																	handlePlano(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='sm:w-full pl-[1px]  w-full min-w-[50px]  h-[full] border-r-[1px]  border-r-black font-semibold content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full sm:text-[14px] text-[8px] overflow-x-auto p-2 text-wrap font-normal'>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																	  ][index][
																			'responsavel'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]
																		?.responsavel
																}
																type='text'
																id={
																	index +
																	' ' +
																	'/' +
																	' ' +
																	'plano_acoes_data'
																}
																name='responsavel'
																className='appearance-none  text-base leading-8 w-[95%] font-normal'
																onChange={(e) =>
																	handlePlano(
																		e.target
																			.id,

																		e.target
																			.name,

																		e.target
																			.value
																	)
																}></input>
														)}
													</div>
													<div className='w-full  h-[full]  font-semibold content-center text-center '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full sm:text-[14px] text-[12px] overflow-x-auto p-2 text-wrap font-normal'>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																	  ][index][
																			'prazo'
																	  ]
																	: null}
															</div>
														) : (
															<input
																defaultValue={
																	invForm
																		?.plano_acoes_data[
																		index
																	]?.prazo
																}
																type='number'
																id={`${index} / plano_acoes_data`}
																name='prazo'
																placeholder='somente números'
																className='appearance-none text-base leading-8 w-[95%]  font-normal'
																onChange={(
																	e
																) => {
																	const prazo =
																		e.target
																			.value;
																	const maxPrazo = 32767; // Número máximo permitido
																	if (
																		parseInt(
																			prazo
																		) >
																		maxPrazo
																	) {
																		alert(
																			`O valor do prazo não pode ser maior que ${maxPrazo}.`
																		);
																	} else {
																		handlePlano(
																			e
																				.target
																				.id,
																			e
																				.target
																				.name,
																			prazo
																		);
																	}
																}}
															/>
														)}
													</div>
													<div className='sm:w-[99.6%]  w-full h-[full] border-[1px] pl-[1px] min-w-[50px]  font-semibold content-center text-center border-l-black '>
														{notificacao?.status ===
															'INVESTIGADO' ||
														notificacao?.status ===
															'CONCLUIDO' ? (
															<div className='w-full sm:text-[14px] text-[10px]  overflow-x-auto p-2 text-wrap font-normal'>
																{invForm[
																	'plano_acoes_data'
																]
																	? invForm[
																			'plano_acoes_data'
																	  ][index][
																			'status'
																	  ]
																			.replace(
																				/_/g,
																				' '
																			)
																			.toLowerCase()
																			.replace(
																				/^./,
																				(
																					c
																				) =>
																					c.toUpperCase()
																			)
																	: null}
															</div>
														) : (
															<select
																defaultValue={
																	invForm?.plano_acoes_data[
																		index
																	]?.status?.toUpperCase() ||
																	'PENDENTE'
																}
																id={
																	index +
																	' / plano_acoes_data'
																}
																name='status'
																className=' text-base h-[95%]  w-[95%] font-normal'
																onChange={(e) =>
																	handlePlano(
																		e.target
																			.id,
																		e.target
																			.name,
																		e.target
																			.value
																	)
																}>
																<option value='PENDENTE'>
																	Pendente
																</option>
																<option value='EM_ANDAMENTO'>
																	Em andamento
																</option>
																<option value='CONCLUIDO'>
																	Concluido
																</option>
																<option value='CANCELADO'>
																	Cancelado
																</option>
															</select>
														)}
													</div>
												</div>
											</div>
										)
									)}
									{notificacao?.status === 'CLASSIFICADO' ? (
										<div>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#525252] text-[#9e9e9e] rounded px-1 shadow-md'
												}`}
												id='adcionar'
												onClick={(event) =>
													addPlano(event.target.id)
												}>
												{' '}
												Adicionar{' '}
											</button>
											<button
												className={`${
													formLayout
														? 'hidden '
														: 'absolute font-bold bg-[#E3E3E3] hover:bg-[#b8b8b8] my-1 text-[13px] hover:text-[#525252] text-[#9e9e9e] rounded px-1 shadow-md ml-20'
												}`}
												id='remover'
												onClick={(event) =>
													addPlano(event.target.id)
												}>
												{' '}
												Remover{' '}
											</button>
										</div>
									) : null}
								</div>
							) : null}
						</div>
						<div id='block3'>
							{((notificacao?.status === 'INVESTIGADO' &&
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO') ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div className='w-full my-5 border-[1px]  border-black'>
									<div
										className={`${
											formLayout
												? 'w-full bg-gray-300 py-1 border-black border-b-[1px] text-center font-bold pb-4'
												: 'w-full bg-gray-300 py-1 border-black border-b-[1px] text-center font-bold'
										}`}>
										AVALIAÇÃO FINAL
									</div>

									{/* {console.log(finalForm)} */}
									<div className='w-full flex gap-2 py-1 text-start px-2 border-black   font-normal text-[14px] sm:text-[16px]'>
										As ações realizadas foram suficientes
										bloquear a reincidência do incidente?
										<div className='flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]'>
											<input
												type='radio'
												name='acoes_realizadas'
												id='sim'
												className={` w-3 w-auto${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
												checked={
													!notificacao?.status ===
													'CONCLUIDO'
														? undefined
														: !finalForm?.acoes_realizadas ===
														  ''
														? undefined
														: finalForm?.acoes_realizadas
												}
												onChange={(e) => {
													return notificacao?.status ===
														'CONCLUIDO'
														? 0
														: handleFinal(
																e.target.name,
																e.target.id
														  );
												}}></input>
											SIM
											<input
												type='radio'
												name='acoes_realizadas'
												id='nao'
												checked={
													!notificacao?.status ===
													'CONCLUIDO'
														? undefined
														: !finalForm.acoes_realizadas ===
														  ''
														? undefined
														: !finalForm?.acoes_realizadas
												}
												className={`w-3 w-auto${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
												onChange={(e) => {
													return notificacao?.status ===
														'CONCLUIDO'
														? 0
														: handleFinal(
																e.target.name,
																e.target.id
														  );
												}}></input>
											NÃO
										</div>
									</div>
									<div
										className={`${
											formLayout
												? 'w-full flex gap-2 py-1 text-start px-2 border-black border-b-[1px]  font-normal text-[16px] mb-4'
												: 'w-full flex gap-2 py-1 text-start px-2 border-black border-b-[1px]  font-normal text-[14px] sm:text-[16px]'
										}`}>
										Foi criado ou alterado algum padrão de
										trabalho para evitar a reincidência do
										incidente?
										<div className='flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]'>
											<input
												type='radio'
												name='padroes_trabalho'
												id='sim'
												className={`${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
												checked={
													!notificacao?.status ===
													'CONCLUIDO'
														? undefined
														: !finalForm.padrao_trabalho ===
														  ''
														? undefined
														: finalForm?.padrao_trabalho
												}
												onChange={(e) => {
													return notificacao?.status ===
														'CONCLUIDO'
														? 0
														: handleFinal(
																e.target.name,
																e.target.id
														  );
												}}></input>
											SIM
											<input
												type='radio'
												name='padroes_trabalho'
												id='nao'
												className={`${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
												checked={
													!notificacao?.status ===
													'CONCLUIDO'
														? undefined
														: !finalForm.padrao_trabalho ===
														  ''
														? undefined
														: !finalForm?.padrao_trabalho
												}
												onChange={(e) => {
													return notificacao?.status ===
														'CONCLUIDO'
														? 0
														: handleFinal(
																e.target.name,
																e.target.id
														  );
												}}></input>
											NÃO
										</div>
									</div>

									{/* 	{console.log(finalForm)} */}
									{notificacao?.status === 'CONCLUIDO' ? (
										<div className='p-2 w-full h-36 mt-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none break-words overflow-y-auto'>
											{finalForm.observacoes
												? finalForm.observacoes
												: null}
										</div>
									) : (
										<textarea
											className='p-2 w-full h-36 mt-2 text-sm text-gray-700 border-none focus:outline-none focus:ring-0 resize-none'
											placeholder='Observações:'
											name='observacoes'
											onChange={(e) => {
												handleFinal(
													e.target.name,
													e.target.value
												);
											}}></textarea>
									)}
								</div>
							) : null}
						</div>
						<div id='block4'>
							{((notificacao?.status === 'INVESTIGADO' &&
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO') ||
								notificacao?.status === 'CONCLUIDO') &&
							notificacao?.classificacao?.descartar !== true &&
							concluido === false ? (
								<div className='w-full my-5  '>
									<div
										className={`${'w-full bg-gray-300 py-1 text-center border-black border-[1px] border-b-[0px]  font-bold'}`}></div>
									<div
										className={`${'w-full flex gap-2 py-1 text-start px-2 border-black border-[1px] border-t-[0px]  font-normal text-[16px]'}`}>
										Corrigir tipo ou a classficação do
										incidente ?
										<div
											className={`flex gap-1 content-center items-center align-middle text-[12px] sm:text-[16px]`}>
											{/* SIM */}
											<input
												type='radio'
												name='reclassificacao'
												checked={
													finalForm?.tipo_incidente_final ||
													finalForm?.classificacao_final
														? true
														: notificacao.status ===
														  'CONCLUIDO'
														? false
														: reclass === true
												}
												onChange={(e) => {
													if (
														notificacao.status !==
														'CONCLUIDO'
													) {
														setReclass(true);
													}
												}}
												id='sim'
												className={`w-3 sm:w-auto ${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
											/>
											SIM
											{/* NÃO */}
											<input
												type='radio'
												name='reclassificacao'
												checked={
													!finalForm?.tipo_incidente_final &&
													!finalForm?.classificacao_final
														? notificacao.status ===
														  'CONCLUIDO'
															? true
															: reclass === false
														: false
												}
												onChange={(e) => {
													if (
														notificacao.status !==
														'CONCLUIDO'
													) {
														setReclass(false);
														setSubReclassForm('');
													}
												}}
												id='nao'
												className={`w-3 sm:w-auto ${
													formLayout
														? 'mt-3 mr-1'
														: ''
												}`}
											/>
											NÃO
										</div>
									</div>

									<div
										className={` overflow-hidden duration-700 transition-all  ${
											reclass
												? formLayout
													? 'h-[900px]'
													: 'h-[auto] sm:h-[780px]'
												: 'h-[0px]'
										}`}>
										<div className='w-full'>
											<div className='flex flex-col gap-2 py-3  px-4 border-black border-[1px] border-t-[0] border-b-[0] '>
												<p className='font-bold text-gray-600 my-2 text-[22px]'>
													Nova Classificação
												</p>
												{classificacoes.map(
													(evento) => (
														<div
															key={
																evento.display +
																'ca'
															}
															className={`flex items-start gap-2`}>
															<input
																type='radio'
																name='option'
																checked={
																	finalForm?.classificacao_final
																		? evento.display ===
																		  finalForm?.classificacao_final
																		: undefined
																}
																id='reclass'
																onChange={() =>
																	handleReclassForm(
																		evento.display
																	)
																}
																value={
																	evento.display
																}
															/>
															<label
																htmlFor={
																	evento.display
																}
																className={`
																		flex gap-2
																`}>
																<p className='text-sm font-normal content-center'>
																	<span className='font-bold'>
																		{
																			evento.value
																		}
																		:
																	</span>{' '}
																	{
																		evento.descricao
																	}
																</p>
															</label>
														</div>
													)
												)}

												<div className='flex items-start gap-2'>
													<input
														type='radio'
														name='option'
														checked={
															finalForm?.classificacao_final
																? 'NEVER_EVENTS' ===
																  finalForm?.classificacao_final
																: undefined
														}
														id='reclass'
														value='NEVER_EVENTS'
														onChange={() =>
															handleReclassForm(
																'NEVER_EVENTS'
															)
														}
														className='mt-[4px]'
													/>
													<label
														htmlFor='never'
														className={`${
															formLayout
																? 'flex gap-2'
																: 'flex gap-2'
														}`}>
														<div className='text-sm font-normal content-center flex gap-2'>
															<span className='font-bold'>
																Never Events:
															</span>{' '}
															{finalForm?.sub_classificacao_final !==
															undefined ? (
																<div>
																	{finalForm?.sub_classificacao_final ===
																	''
																		? 'Nenhum never event'
																		: NeverJson?.filter(
																				(
																					item
																				) =>
																					item.codigo ===
																					finalForm?.sub_classificacao_final
																		  )[0]
																				?.descricao}
																</div>
															) : (
																<select
																	className='w-[290px] bg-[#f0f0f0] p-1 rounded-md  '
																	onChange={
																		handleSubReclassForm
																	}
																	id='sub_reclass'>
																	<option
																		value=''
																		className=''>
																		Escolha
																		um valor
																		de
																		acordo
																		com o
																		evento
																	</option>
																	{NeverJson.map(
																		(
																			item,
																			index
																		) => (
																			<option
																				key={
																					index +
																					'ga'
																				}
																				id='sub_reclass'
																				value={
																					item.codigo
																				}
																				className='flex mb-10'>
																				{item.codigo +
																					' ' +
																					item.descricao}
																			</option>
																		)
																	)}
																</select>
															)}
														</div>
													</label>
												</div>
											</div>
										</div>
										<div className='w-full border-[1px] border-t-[0px] border-black p-4'>
											<p className='font-bold text-gray-600 my-2 text-[22px]'>
												Novo tipo de incidente
											</p>
											<div
												className={`${
													formLayout
														? 'grid grid-cols-2 gap-4'
														: 'grid grid-cols-1 lg:grid-cols-2 gap-4'
												}`}>
												{tiposIncidentes.map(
													(incident, index) => (
														<label
															key={index + 'bo'}
															className='flex items-center sm:whitespace-nowrap'>
															<input
																type='radio'
																name='reclassIncidente'
																checked={
																	finalForm?.tipo_incidente_final
																		? finalForm?.tipo_incidente_final ===
																		  incident.value
																		: undefined
																}
																onChange={() =>
																	handleReIncident(
																		incident.value
																	)
																}
																value={
																	incident.display
																}
																id={
																	incident.display
																}
																className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
															/>
															<span
																className={`${
																	formLayout
																		? 'ml-2 text-gray-700 mb-2 text-base'
																		: 'ml-2 text-gray-700 text-sm md:text-base '
																}`}>
																{
																	incident.display
																}
															</span>
														</label>
													)
												)}
												{/* <label className='flex items-center whitespace-nowrap'>
													<input
														type='radio'
														name='tipo_incidente'
														value='OUTROS'
														className='form-radio h-3 w-3 md:h-4 md:w-4 text-blue-600'
													/>
													<span className='ml-2 text-gray-700 flex items-center w-10/12 text-sm md:text-base'>
														Outro:
														{notificacao
															?.tipo_incidente_outros
															?.length > 0 ? (
															<div
																type='text'
																name='tipo_incidente'
																className='ml-2 w-full h-6 text-xs md:text-sm border-b-[1px] border-gray-500  focus:outline-none'>
																{
																	notificacao?.tipo_incidente_outros
																}
															</div>
														) : null}
													</span>
												</label> */}
											</div>
										</div>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			)}
			{!enviado && (
				<div className='flex justify-between sm:flex-row flex-col  mx-auto w-full sm:max-w-[1130px] max-w-[100vw] mt-10 px-4 sm:px-6 lg:px-8'>
					<div className='flex justify-start sm:items-start items-center sm:gap-0   text-red-500  flex-col'>
						{showAlert && (
							<div className='font-semibold w-[50%] leading-5'>
								Por favor, preencha todos os campos
								obrigatórios.
							</div>
						)}
						<button
							className={`enabled:bg-[#E3E3E3] max-h-[40px] text-[#a3a3a3] enabled:text-[#757575] flex gap-2 bg-[#d3d3d3]   py-2 px-4 rounded-md enabled:hover:bg-[#757575] enabled:hover:text-[#f0f0f0] transition-all duration-200 focus:outline-none font-semibold ${
								cards.card === 'NOTIFICADO' &&
								cards.caso === 'NOTIFICADO'
									? 'hidden'
									: cards.card === 'INVESTIGADO' &&
									  cards.caso === 'NOTIFICADO' &&
									  notificacao?.status === 'CONCLUIDO'
									? ''
									: cards.card === 'INVESTIGADO' &&
									  cards.caso === 'NOTIFICADO'
									? 'hidden'
									: cards.card === 'CLASSIFICADO' &&
									  cards.caso === 'CLASSIFICADO' &&
									  notificacao?.permissao === true
									? 'hidden'
									: ''
							}`}
							onClick={() => {
								handleGeneratePDF('download');
							}}>
							<div className='flex h-full scale-[130%] mt-1'>
								<FaRegFilePdf />
							</div>
							PDF
						</button>

						<button
							onClick={() => {
								handleSubmit();
							}}
							disabled={isButtonEnabled}
							className={` sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium  sm:w-[330px] justify-center ${
								textBoxSend
									? 'enabled:bg-[#004A80] text-[#ffffff] enabled:text-[#f7f7f7] flex gap-2 rounded-b-none bg-[#d3d3d3] py-2 px-4 rounded-md enabled:hover:bg-[#1d4563] enabled:hover:text-[#f0f0f0]'
									: 'enabled:bg-[#fcfcfc] enabled:hover:border-0 enabled:border-[1px] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px] text-[#E3E3E3] enabled:text-[#757575] flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#a8a8a8] enabled:hover:text-[#ffffff]'
							} ${
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO' &&
								notificacao?.status === 'CONCLUIDO'
									? 'hidden'
									: cards.card === 'INVESTIGADO' &&
									  cards.caso === 'NOTIFICADO' &&
									  notificacao?.status === 'INVESTIGADO'
									? ''
									: cards.card !== cards.caso ||
									  notificacao?.permissao === false
									? 'hidden'
									: ''
							}`}>
							{!buttonLoading ? (
								`Enviar para ${
									cards.card === 'NOTIFICADO' &&
									cards.caso === 'NOTIFICADO'
										? 'Investigação'
										: cards.card === 'CLASSIFICADO' &&
										  cards.caso === 'CLASSIFICADO'
										? 'Avaliação final'
										: 'Conlusão'
								}`
							) : (
								<svg
									aria-hidden='true'
									className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
									viewBox='0 0 100 101'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
										fill='currentColor'
									/>
									<path
										d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
										fill='currentFill'
									/>
								</svg>
							)}
						</button>
						{/* 	{console.log(
							reclassForm.length,
							reIncidentForm.length,
							reclass
						)} */}
						{reclass === true &&
							(reclassForm.length === 0 ||
								(reclassForm === 'NEVER_EVENTS' &&
									subReclassForm.length === 0) ||
								(reclassForm === '' &&
									subReclassForm.length > 0) ||
								reIncidentForm.length === 0) &&
							finalForm?.classificacao_final === undefined &&
							notificacao.status !== 'CONCLUIDO' && (
								<p className='text-red-500 w-full my-5 font-semibold text-center'>
									{' '}
									confirme as mudanças de classificação e tipo
								</p>
							)}

						<div className='relative'>
							<div
								className={`enabled:text-[#929292] flex-col text-sm flex gap-2 rounded-sm rounded-t-none transition-all duration-500 focus:outline-none resize-none font-semibold 
								${
									textBoxSend
										? 'border-[1px] border-[#cfcfcf] sm:w-[330px] rounded-b-md border-t-0 sm:min-h-[80px] pb-4 w-[200px]  sm:h-auto  text-[#757575]'
										: 'w-[100px] h-0 sm:w-[330px] sm:min-h-[0px]  sm:h-0 py-0 px-0 text-[#a3a3a3]'
								}
								${
									cards.card === 'NOTIFICADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'NOTIFICADO'
										? ''
										: 'hidden'
								}`}>
								<div
									className={`flex flex-col gap-3 font-normal text-[#a1a1a1] transition-all duration-800 ${
										textBoxSend
											? 'w-[300px] h-auto px-3 py-3'
											: 'w-[300px] h-0 px-3 py-0 overflow-hidden'
									}`}>
									<div className='flex flex-col gap-1'>
										Encaminhar para investigador?
										<div className='flex gap-2'>
											<label className='flex gap-2'>
												<input
													onChange={() => {
														setYesCheck(false);
														setInvestigadorList([]);
													}}
													type='radio'
													id='encaminhar'
													name='encaminhar'
													value='nao'></input>
												Não
											</label>
											<label className='flex gap-2'>
												<input
													onChange={() => {
														setYesCheck(true);
														requestUsers();
													}}
													type='radio'
													id='encaminhar'
													name='encaminhar'
													value='sim'></input>
												Sim
											</label>
										</div>
									</div>
									{yesCheck && (
										<div className='flex flex-col gap-1'>
											Encaminhar para:
											<select
												className={`border-[1px] p-1 transition-all duration-200 border-gray-200 rounded-sm ${
													invAlert
														? 'border-red-500'
														: 'border-gray-200'
												}`}
												onChange={(e) => {
													handleInvSelected(
														e.target.value
													);
												}}>
												<option>
													Selecione o Investigador
												</option>

												{invUsers.map((user, index) => (
													<option
														key={index}
														value={user?.email}>
														{user?.nome}
													</option>
												))}
											</select>
											{/* Renderizando a lista de investigadores atualizada */}
											{!isLoading ? (
												<div className='w-full px-2 text-[#9e9e9e]'>
													{investigadorList.map(
														(item, index) => (
															<div key={index}>
																{item}
															</div>
														)
													)}
												</div>
											) : (
												'carregando...'
											)}
										</div>
									)}

									{yesCheck ? (
										<div className='w-full gap-1 flex justify-center mb-1'>
											<button
												onClick={() => {
													if (
														investigadorList.length >
														0
													) {
														let a =
															investigadorList;
														a.pop();
														setInvestigadorList(a);
														setIsLoading(true);
														setTimeout(() => {
															setIsLoading(false);
														}, 1000);
													}
												}}
												className='border-[1px] w-[30px] h-[30px]  border-[#cecece] rounded-md duration-200 transition-all text-xl align-top items-start content-start hover:bg-[#cecece] hover:text-white'>
												-
											</button>
										</div>
									) : null}
								</div>
							</div>
						</div>
					</div>

					<div className='flex mt-10 sm:mt-0 flex-col sm:items-start items-center'>
						<button
							onClick={handleInvalid}
							className={` sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium w-[200px]  sm:w-[330px] justify-center ${
								textBox
									? 'enabled:bg-[#004A80] text-[#ffffff] enabled:text-[#f7f7f7] flex gap-2 rounded-b-none bg-[#d3d3d3] py-2 px-4 rounded-md enabled:hover:bg-[#1d4563] enabled:hover:text-[#f0f0f0]'
									: 'enabled:bg-[#fcfcfc] enabled:hover:border-0 enabled:border-[1px] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px] text-[#E3E3E3] enabled:text-[#757575] flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#a8a8a8] enabled:hover:text-[#ffffff]'
							} ${
								cards.card === 'NOTIFICADO' &&
								cards.caso === 'NOTIFICADO' &&
								notificacao?.status === 'NOTIFICADO'
									? ''
									: 'hidden'
							}`}>
							{'Concluir Notificação'}
						</button>
						<button
							onClick={() => handleSaveInv()}
							disabled={formSalvo}
							className={`relative sm:max-h-[40px] h-auto max-h-[40px] transition-all duration-200 focus:outline-none font-medium  sm:w-[330px] justify-center ${
								textBoxSend
									? 'enabled:bg-[#004A80] text-[#ffffff] enabled:text-[#f7f7f7] flex gap-2 rounded-b-none bg-[#d3d3d3] py-2 px-4 rounded-md enabled:hover:bg-[#1d4563] enabled:hover:text-[#f0f0f0]'
									: 'enabled:bg-[#fcfcfc] enabled:hover:border-0 enabled:border-[1px] enabled:border-[#dbdbdb] border-[#f1f1f1] border-[1px] text-[#E3E3E3] enabled:text-[#757575] flex gap-2  py-2 px-4 rounded-md enabled:hover:bg-[#a8a8a8] enabled:hover:text-[#ffffff]'
							} ${
								cards.card === 'CLASSIFICADO' &&
								cards.caso === 'CLASSIFICADO' &&
								notificacao?.permissao === true
									? ''
									: 'hidden'
							}`}>
							{carregando ? (
								<svg
									aria-hidden='true'
									className='w-5 h-5 text-gray-200 animate-spin  my-auto  fill-blue-600'
									viewBox='0 0 100 101'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
										fill='currentColor'
									/>
									<path
										d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
										fill='currentFill'
									/>
								</svg>
							) : formSalvo ? (
								'Alterações Salvas!'
							) : (
								'Salvar Alterações'
							)}
						</button>
						{(rejectCard === 'clicked' ||
							rejectCard === 'send') && (
							<div className='fixed inset-0 flex items-center justify-center bg-black/50 z-50'>
								<div className='shadow-lg flex flex-col  text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4  rounded-xl'>
									<div className=''></div>
									{rejectCard === 'clicked' && (
										<>
											<p className='text-[#a3a3a3] text-lg'>
												Deseja Realmente Retornar esta
												notificação ao investigador?
											</p>
											<div className='flex justify-center gap-4'>
												<button
													onClick={() =>
														handleReject()
													}
													className='bg-[#004A80] rounded-md p-1 px-5 text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
													Sim
												</button>{' '}
												<button
													onClick={() =>
														setRejectCard('')
													}
													className='p-1 px-5 rounded-md bg-[#004A80] text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
													Não
												</button>
											</div>
										</>
									)}
									{rejectCard === 'send' && (
										<>
											<p>
												A notificação foi retornada com
												sucesso!
											</p>
											<a
												alt='link para retornar a pagina de avaliação de notificações'
												href='/notes-avaliation'
												className='text-[#3591d3] hover:text-[#3591d3]'>
												Retornar
											</a>
										</>
									)}
								</div>
							</div>
						)}
						<button
							onClick={() => {
								handleReject();
							}}
							className={` py-2 px-4 rounded-md  w-[300px] justify-center  max-h-[40px] transition-all duration-200 flex gap-2 focus:outline-none font-semibold ${
								rejeicao.length > 0
									? 'bg-[#004A80] text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'
									: 'enabled:bg-[#ffffff] text-[#cfcfcf] enabled:text-[#b1b1b1] enabled:border-[#c7c7c7] border-[1px]  bg-[#d3d3d3] enabled:hover:bg-[#c7c7c7] enabled:hover:text-[#ffffff] '
							} ${
								cards.card === 'INVESTIGADO' &&
								cards.caso === 'NOTIFICADO' &&
								notificacao?.status === 'INVESTIGADO'
									? ''
									: 'hidden'
							}`}>
							Retornar para Investigação
						</button>
						<div className='relative'>
							<div
								className={`absolute top-2 right-2 text-[#b4b4b4] font-semibold z-40 hover:text-[#777777] ${
									textBox ? '' : 'hidden'
								}`}>
								<button
									onClick={() => {
										setTextBox(false);
										setJustificativa('');
										setEmailCounter(1);
									}}>
									<IoMdClose />
								</button>
							</div>
							<div
								className={`enabled:text-[#929292] flex-col text-sm flex gap-2 rounded-sm rounded-t-none  transition-all duration-500 focus:outline-none resize-none  font-semibold 
								${
									textBox
										? 'border-[1px] border-[#cfcfcf] sm:w-[330px] rounded-b-md border-t-0 sm:min-h-[235px] sm:h-auto w-[200px] h-[200px] text-[#757575]'
										: 'w-[100px] h-0 sm:w-[330px] sm:min-h-[0px]  sm:h-0 py-0 px-0 text-[#a3a3a3]'
								}
								${
									cards.card === 'NOTIFICADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'NOTIFICADO'
										? ''
										: 'hidden'
								}`}>
								<textarea
									type='text'
									placeholder='Observação:'
									onChange={(e) => {
										setJustificativa(e.target.value);
										setJustAlert(false);
									}}
									value={justificativa}
									className={`text-[12px] sm:text-sm flex gap-2 border-1   rounded-t-none transition-all duration-500 focus:outline-none resize-none  font-semibold ${
										justAlert
											? 'placeholder:text-[#B74644] rounded-b-none'
											: ''
									}
										${
											textBox
												? 'py-2  px-2 sm:px-4 sm:w-full rounded-b-md sm:h-[150px] w-[200px] h-auto text-[#757575]'
												: 'w-[100px] h-0 sm:w-[330px] sm:h-0 py-0 px-0 text-[#a3a3a3]'
										}
										${
											cards.card === 'NOTIFICADO' &&
											cards.caso === 'NOTIFICADO' &&
											notificacao?.status === 'NOTIFICADO'
												? ''
												: 'hidden'
										}`}></textarea>
								{textBox ? (
									<div className='flex flex-col gap-1'>
										<div className='text-[#afafaf] px-2'>
											Encaminhe a notificação para:{' '}
										</div>
										{Array(emailCounter)
											.fill(10)
											.map((item, index) => (
												<div
													key={index + 'foli'}
													className='w-full flex justify-center'>
													<input
														onChange={(e) => {
															handleEmails(
																index,
																e.target.value
															);
															setEmailsAlert(
																false
															);
														}}
														type='text'
														placeholder='Digite o E-mail'
														className={`rounded-md  transition-all duration-300 w-[96%] px-2 py-2 font-  border-[1px] font-inter text-[14px]  ${
															emailsAlert
																? 'border-[1px] border-[#B74644] placeholder:text-[#B74644] '
																: 'border-[#dfdfdf]'
														}}`}></input>
												</div>
											))}
										<div className='w-full gap-1 flex justify-center mb-4'>
											<button
												onClick={() =>
													emailCounter < 3 &&
													setEmailCounter(
														emailCounter + 1
													)
												}
												className='border-[1px] w-[30px] h-[30px]  border-[#cecece] rounded-md duration-200 transition-all text-xl align-top items-start content-start hover:bg-[#cecece] hover:text-white'>
												+
											</button>
											<button
												onClick={() => {
													emailCounter > 1 &&
														setEmailCounter(
															emailCounter - 1
														);
													let a = concludeEmails;
													a.pop();
													setConcludeEmails(a);
												}}
												className='border-[1px] w-[30px] h-[30px]  border-[#cecece] rounded-md duration-200 transition-all text-xl align-top items-start content-start hover:bg-[#cecece] hover:text-white'>
												-
											</button>
										</div>
									</div>
								) : null}
							</div>
						</div>

						<div className='relative my-2'>
							<div
								className={`absolute top-2 right-2 text-[#b4b4b4] font-semibold z-40 hover:text-[#777777] ${
									textReject ? '' : 'hidden'
								}`}>
								<button
									onClick={() => {
										setTextReject(false);
										setRejeicao('');
									}}>
									<IoMdClose />
								</button>
							</div>
							<textarea
								type='text'
								placeholder='Justificativa'
								onChange={(e) => setRejeicao(e.target.value)}
								value={rejeicao}
								className={`enabled:bg-[#f5f5f5]   text-[#a3a3a3] enabled:text-[#929292] text-sm flex gap-2 bg-[#dadada]   rounded-md  transition-all duration-500 focus:outline-none resize-none  font-semibold 
								${textReject ? 'py-2 px-4 w-[300px] h-[200px]' : 'w-[300px] h-[0px] py-0 px-0'}
								${
									cards.card === 'INVESTIGADO' &&
									cards.caso === 'NOTIFICADO' &&
									notificacao?.status === 'INVESTIGADO'
										? ''
										: 'hidden'
								}`}></textarea>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default ClassInvForm;
